import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { createRoot } from "react-dom/client";
import DataTable from "react-data-table-component";
import ButtonIconH from "../components/ButtonIconH";
import PrintExportMenu from "../support-extra/components/PrintExportMenu";
import { exportToFile } from "../support-extra/js/exportToFile";
import { openWhatsapp } from "../support-extra/js/comms";
import { validateNIF } from "../support-extra/js/nif";
import { formatCurrency } from "../support-extra/utils/utils";
import Tag from "../components/Tag";
import Dropdown from "../components/Dropdown";
import {
  sexOptions,
  avatarImg,
  userData,
  selectedOptic,
  svgIcons,
  provinceOptions,
  patientData,
  inputOnEnter,
  focusElement,
  numOptometriesStruct,
  calculateAge,
  formatValueUnit,
} from "../js/utils";
import { post } from "../js/post";
import { post as rpost } from "../support-extra/js/api";
import { useAmetropias } from "../hooks/useAmetropias";
import InputData from "../components/InputData";
import CheckBox from "../components/CheckBox";
import InputSearch from "../components/InputSearch";
import PopupNIFTypes from "../components/PopupNIFTypes";
import LoadingScreen from "../components/LoadingScreen";
import WebCam from "../components/WebCam";
import ButtonSectionHeader from "../components/ButtonSectionHeader";
import OptometryHistoryBox from "../components/OptometryHistoryBox";
import ButtonIconV from "../components/ButtonIconV";
import HealthData from "../support-extra/components/HealthData";
import GlassesHistoryBox from "../components/GlassesHistoryBox";
import AudiometryHistoryBox from "../components/AudiometryHistoryBox";
import HearingAidsHistoryBox from "../components/HearingAidsHistoryBox";
import ContactLensesHistoryBox from "../components/ContactLensesHistoryBox";
import InputIconSearch from "../components/InputIconSearch";
import TooltipBox from "../components/Tooltip";
import "../css/Patient.css";
import "../css/Panel.css";
import moment from "moment";
import { reformatField } from "../js/format";
import PatientSaleHistory from "../support-extra/components/PatientSaleHistory";
import { transformPatientPicture } from "../support-extra/utils/patients";
import RadioButton from "../components/RadioButton";
import { useCampaigns } from "../hooks/useCampaigns";
import CashVoucherPopup from "../support-extra/components/CashVoucherPopup";
import LoyaltyPopup from "../support-extra/components/LoyaltyPopup";
import SendSMSPopup from "../support-extra/components/SendSMSPopup";
import { PatientNotifications } from "../components/PatientNotifications";
import { useRecommended } from "../hooks/useRecommended";
import { useHobbies } from "../hooks/useHobbies";
import { GDPRConsent } from "../components/GDPRConsent";
import { PatientDocumentManagement } from "../components/PatientDocumentManagement";
import { LCConsent } from "../components/LCConsent";
import { ORTHOKConsent } from "../components/ORTHOKConsent";
import { AudioConsent } from "../components/AudioConsent";
import { useDocumentTypes } from "../hooks/useDocumentTypes";

const Patient = forwardRef((props, ref) => {
  const [toggleDataSection, setToggleDataSection] = useState(true);
  const [togglePurchasingSection, setTogglePurchasingSection] = useState(true);
  const [toggleOptometrySection, setToggleOptometrySection] = useState(true);
  const [toggleEyeglassesSection, setToggleEyeglassesSection] = useState(true);
  const [toggleContactLensesSection, setToggleContactLensesSection] =
    useState(true);
  const [toggleAudiometrySection, setToggleAudiometrySection] = useState(true);
  const [toggleHearingAidsSection, setToggleHearingAidsgSection] =
    useState(true);
  const [existPatient, setExistPatient] = useState(false);
  const [identityNumberTypes, setIdentityNumberTypes] = useState(false);
  const [currentPatient, setCurrentPatient] = useState(patientData);
  const [currentPatientEdit, setCurrentPatientEdit] = useState(patientData);
  const [patientAge, setPatientAge] = useState("");
  const [selectedHobby, setSelectedHobby] = useState({ id: "", text: "" });
  const [selectedAmetropia, setSelectedAmetropia] = useState("");
  const [patientPicture, setPatientPicture] = useState(avatarImg);
  const campaignList = [{ id: "", text: "" }, ...useCampaigns()];
  const recommendedList = [{ id: "", text: "" }, ...useRecommended()];
  const hobbiesList = [{ id: "", text: "" }, ...useHobbies()];
  const ametropiaList = useAmetropias();
  const [headerName, setHeaderName] = useState("NUEVO PACIENTE");
  const [loadingPatient, setLoadingPatient] = useState(false);
  const [patientDataChanges, setPatientDataChanges] = useState(false);
  const [patientReadyToSave, setPatientReadyToSave] = useState(false);
  const [forceReload, setForceReload] = useState(false);
  const [optometrySectionSeeMore, setOptometrySectionSeeMore] = useState(false);
  const [audiometrySectionSeeMore, setAudiometrySectionSeeMore] =
    useState(false);
  const [glassesSectionSeeMore, setGlassesSectionSeeMore] = useState(false);
  const [hearingAidsSeeMore, setHearingAidsSeeMore] = useState(false);
  const [CLSeeMore, setCLSeeMore] = useState(false);
  const [optometryHistoryList, setOptometryHistoryList] = useState([]);
  const [audiometryHistoryList, setAudiometryHistoryList] = useState([]);
  const [glassesHistoryList, setGlassesHistoryList] = useState([]);
  const [hearingAidsHistoryList, setHearingAidsHistoryList] = useState([]);
  const [CLHistoryList, setCLHistoryList] = useState([]);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorCP, setErrorCP] = useState(false);
  const [numOptometries, setNumOptometries] = useState(null);
  const [recentOptometryIds, setRecentOptometryIds] = useState({
    optometria: null,
    anamnesis: null,
    refractivo: null,
    oculomotor: null,
    binocular: null,
    acomodativo: null,
    sensorial: null,
    saludOcular: null,
  });
  let [patientId, setPatientId] = useState(null);
  const [numObservations, setNumObservations] = useState(0);
  const [healthData, setHealthData] = useState([]);
  const healthDataRef = useRef(null);
  const [numSC, setNumSC] = useState(0);
  const [patientCode, setPatientCode] = useState("");
  const [salesExportData, setSalesExportData] = useState(null);
  const [floatingMenu, setFloatingMenu] = useState(false);
  const [showCashVoucherPopup, setShowCashVoucherPopup] = useState(false);
  const [numCashVouchers, setNumCashVouchers] = useState(0);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const photoRef = useRef(null);
  const [cameraActive, setCameraActive] = useState(false);
  const menuRef = useRef(null);
  const cancellingCreationRef = useRef(false);
  const [history, setHistory] = useState({});
  const [handleGDPRConsent, setHandleGDPRConsent] = useState(false);
  const [handleLCConsent, setHandleLCConsent] = useState(false);
  const [handleORTHOKConsent, setHandleORTHOKConsent] = useState(false);
  const [handleAudioConsent, setHandleAudioConsent] = useState(false);
  const initialCheckboxState = {
    checkboxServices:
      currentPatientEdit.serviciosEmail &&
      currentPatientEdit.serviciosPostal &&
      currentPatientEdit.serviciosSMS &&
      currentPatientEdit.serviciosTelefono &&
      currentPatientEdit.serviciosWhatsapp,
    checkboxCommercial:
      currentPatientEdit.comercialEmail &&
      currentPatientEdit.comercialPostal &&
      currentPatientEdit.comercialSMS &&
      currentPatientEdit.comercialTelefono &&
      currentPatientEdit.comercialWhatsapp,
  };
  const [checkboxState, setCheckboxState] = useState(initialCheckboxState);
  const [showLoyaltyPopup, setShowLoyaltyPopup] = useState(false);
  const [opticConfig, setOpticConfig] = useState({
    idFidelizacion: "",
    confTicketDobleCopiaVenta: false,
    controlSanitario: false,
    localidadOptica: "",
    provinciaOptica: "",
  });
  const [showSendSMSPopup, setShowSendSMSPopup] = useState(false);
  useImperativeHandle(ref, () => ({
    onChangeScreen,
  }));
  const [handleDocumentManagement, setHandleDocumentManagement] =
    useState(false);
  const [numFilesDM, setNumFilesDM] = useState(0);
  const [consentChanges, setConsentChanges] = useState(false);
  const [documentTypesList] = useDocumentTypes();
  const [selectedDocumentType, setSelectedDocumentType] = useState({
    description: "NIF",
    documentId: "01",
    idNif: "00",
  });

  const handlePatientWhatsapp = () => {
    if (currentPatient.movil === "") {
      props.createPopupQuestion(
        "El paciente no tienen ningún Móvil asignado.",
        props.removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    openWhatsapp(currentPatient.movil);
  };

  const openEmail = () => {
    if ((currentPatientEdit?.email ?? "") === "") {
      props.createPopupQuestion(
        "El paciente no tienen ningún Email asignado.",
        props.removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    const mailto = (
      "mailto:" + (currentPatientEdit?.email ?? "")
    ).toLowerCase();
    const isSupported = window.navigator && window.navigator.msLaunchUri;

    if (isSupported) {
      // Edge
      window.navigator.msLaunchUri(mailto, null, () => {});
    } else {
      window.location.href = mailto;
    }
  };

  const uploadNewPatientPic = async () => {
    const fileInput = document.querySelector('input[type="file"]');
    const pic = fileInput.files[0];

    if (pic) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const base64String = event.target.result;
        setPatientPicture(base64String);
        await savePatientPic(base64String, pic.name);
      };

      reader.readAsDataURL(pic);
    }
  };

  const createPatient = async (config = opticConfig) => {
    // Localidad y provincia por defecto: las de la óptica, si las tiene.
    const newPatientData = {
      ...patientData,
      localidad:
        config.localidadOptica !== ""
          ? config.localidadOptica
          : patientData.localidad,
      provincia:
        config.provinciaOptica !== ""
          ? config.provinciaOptica
          : patientData.provincia,
    };
    setPatientId(-1);
    setCurrentPatient(newPatientData);
    setCurrentPatientEdit(newPatientData);
    setHeaderName("NUEVO PACIENTE");
    setPatientPicture(avatarImg);
    setPatientAge("");
    setOptometryHistoryList([]);
    setAudiometryHistoryList([]);
    setGlassesHistoryList([]);
    setHearingAidsHistoryList([]);
    setCLHistoryList([]);
    setLoadingPatient(false);
    setExistPatient(true);
    setNumOptometries(numOptometriesStruct);
    setRecentOptometryIds({
      optometria: -1,
      anamnesis: -1,
      refractivo: -1,
      oculomotor: -1,
      binocular: -1,
      acomodativo: -1,
      sensorial: -1,
      saludOcular: -1,
    });
    setSelectedAmetropia([{ id: "", text: "" }, ...ametropiaList][0].id);
  };

  const deletePatientPicture = async () => {
    if (currentPatientEdit.sexo === "HOMBRE") {
      setPatientPicture("/images/support-extra/hombre.svg");
    } else if (currentPatientEdit.sexo === "MUJER") {
      setPatientPicture("/images/support-extra/mujer.svg");
    } else {
      setPatientPicture("/images/avatar.svg");
    }
    await savePatientPic("", "");
  };

  const deletePatient = async () => {
    await post("EliminarPaciente.php", {
      token: userData.token,
      idPaciente: patientId,
      optica: selectedOptic.id,
    });
  };

  const getPatientHistory = async (id) => {
    const response = await post("ObtenerHistorialPaciente.php", {
      token: userData.token,
      idPaciente: id,
      optica: selectedOptic.id,
    });
    setHistory(response);
  };

  const getPatientId = async () => {
    const response = await post("ObtenerIdentificadorPaciente.php", {
      token: userData.token,
      optica: selectedOptic.id,
      codigoPaciente: patientCode,
    });
    if (response.error !== "") {
      focusElement(0);
      props.createPopupQuestion(
        response.error,
        () => {
          focusElement(0);
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      setPatientId(response.idPaciente);
      await getPatientData(response.idPaciente);
      await getPatientPicture(response.idPaciente);
    }
  };

  const validateDate = (e) => {
    const dateValue = e.target.value;
    if (!dateValue) {
      setPatientAge("");
      return;
    }

    // Extraer el año del formato YYYY-MM-DD
    const yearString = dateValue.split("-")[0];

    if (yearString.length !== 4) {
      setCurrentPatientEdit({ ...currentPatientEdit, nacimiento: "" });
      focusElement(13);
      setPatientAge("");
      return;
    }

    const year = parseInt(yearString, 10);

    if (year < 1900) {
      setCurrentPatientEdit({ ...currentPatientEdit, nacimiento: "" });
      focusElement(13);
      return;
    }

    if (new Date(dateValue) > new Date()) {
      setCurrentPatientEdit({ ...currentPatientEdit, nacimiento: "" });
      focusElement(13);
      setPatientAge("");
      return;
    }

    calculatePatientAge(dateValue);
  };

  const calculatePatientAge = (dateString) => {
    const age = calculateAge(dateString);
    setPatientAge(age);
  };

  const getObservations = async (pId) => {
    const response = await post("ListarObservaciones.php", {
      token: userData.token,
      optica: selectedOptic.id,
      id: pId,
      categoria: "Paciente",
    });
    setNumObservations(response ? response.length : numObservations);
  };

  const getHealthData = async (pId) => {
    const response = await post("ListarDatosSanitarios.php", {
      token: userData.token,
      idPaciente: pId,
      optica: selectedOptic.id,
      codigos: [],
    });
    setHealthData(response);
  };

  const getFilesDM = async (pId) => {
    const response = await post("ListarFicheros.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: pId,
      categoria: [
        "LOPD",
        "LC",
        "ORTOK",
        "AUDIO",
        "CartaGarantia",
        "JustificanteAsistencia",
      ],
    });
    // console.log(
    // "FICHEROS: ",
    // {
    // token: userData.token,
    // optica: selectedOptic.id,
    // idPaciente: pId,
    // categoria: [
    // "LOPD",
    // "LC",
    // "ORTOK",
    // "AUDIO",
    // "CartaGarantia",
    // "JustificanteAsistencia",
    // ],
    // },
    // response,
    // );
    setNumFilesDM(response.flatMap((e) => e.ficheros).length);
  };

  const getPatientData = async (pId) => {
    setForceReload(true);
    if (pId !== -1) {
      setLoadingPatient(true);
      const response = await post("ObtenerDatosPaciente.php", {
        token: userData.token,
        optica: selectedOptic.id,
        idPaciente: pId,
      });
      if (Object.keys(response).length === 0) {
        setExistPatient(false);
      } else if (response) {
        setExistPatient(true);
        setPatientCode(response.codigo);
        setCurrentPatient({ ...response, idPaciente: pId });
        setCurrentPatientEdit({ ...response, idPaciente: pId });
        setNumCashVouchers(response.numValesCaja);
        calculatePatientAge(response.nacimiento);
        setSelectedAmetropia([{ id: "", text: "" }, ...ametropiaList][0].id);
        setHeaderName(response.nombre + " " + response.apellidos);
        await getOptometryHistory(pId);
        await getAudiometryHistory(pId);
        await getGlassesHistory(pId);
        await getHearingAidsHistory(pId);
        await getCLHistory(pId);
        await getNumOptometries(pId);
        await getNumSC(pId);
        await getObservations(pId);
        await getHealthData(pId);
        await getFilesDM(pId);
        await getPatientHistory(pId);

        localStorage.setItem(
          "lastUser",
          JSON.stringify({
            id: pId,
            name: response.nombre,
            lastName: response.apellidos,
            phone: response.movil !== "" ? response.movil : response.telefono,
          }),
        );
      }
      setLoadingPatient(false);
    } else {
      setExistPatient(true);
    }
  };

  const getPatientPicture = async (pId) => {
    const response = await post("ObtenerFotoPaciente.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: pId,
    });
    setPatientPicture(transformPatientPicture(response.foto));
  };

  const savePatientData = async () => {
    if (patientReadyToSave) {
      if (
        currentPatientEdit.nif !== "" &&
        selectedDocumentType.documentId === "01" &&
        !validateNIF(currentPatientEdit.nif)
      ) {
        props.createPopupQuestion(
          "Número de NIF incorrecto.",
          props.removePopupQuestion,
          null,
          "Entendido",
        );
        return false;
      }
      await post("GuardarDatosPaciente.php", {
        token: userData.token,
        optica: selectedOptic.id,
        idPaciente: patientId,
        nif: currentPatientEdit.nif,
        idNif: currentPatientEdit.idNif,
        fidelizacion: currentPatientEdit.fidelizacion,
        nombre: currentPatientEdit.nombre,
        apellidos: currentPatientEdit.apellidos,
        direccion: currentPatientEdit.direccion,
        localidad: currentPatientEdit.localidad,
        provincia: currentPatientEdit.provincia,
        email: currentPatientEdit.email,
        campana: currentPatientEdit.campana,
        recomendado: currentPatientEdit.recomendado,
        sexo: currentPatientEdit.sexo,
        nacimiento: currentPatientEdit.nacimiento,
        codigoPostal: currentPatientEdit.codigoPostal,
        telefono: currentPatientEdit.telefono,
        movil: currentPatientEdit.movil,
        fax: currentPatientEdit.fax,
        carnetConducir: currentPatientEdit.carnetConducir,
        tieneHijos: currentPatientEdit.tieneHijos,
        codigoRec: currentPatientEdit.codigoRec,
        personaContactoCodigo: currentPatientEdit.personaContactoCodigo,
        personaContactoNombre: currentPatientEdit.personaContactoNombre,
        personaContactoTelefono: currentPatientEdit.personaContactoTelefono,
        trabajoProfesion: currentPatientEdit.trabajoProfesion,
        trabajoEmpresa: currentPatientEdit.trabajoEmpresa,
        trabajoTelefono: currentPatientEdit.trabajoTelefono,
        consentimientosRGPD: currentPatientEdit.consentimientosRGPD,
        consentimientosAudiologia: currentPatientEdit.consentimientosAudiologia,
        consentimientosLC: currentPatientEdit.consentimientosLC,
        consentimientosORTOK: currentPatientEdit.consentimientosORTOK,
        serviciosWhatsapp: currentPatientEdit.serviciosWhatsapp,
        serviciosSMS: currentPatientEdit.serviciosSMS,
        serviciosPostal: currentPatientEdit.serviciosPostal,
        serviciosEmail: currentPatientEdit.serviciosEmail,
        serviciosTelefono: currentPatientEdit.serviciosTelefono,
        comercialWhatsapp: currentPatientEdit.comercialWhatsapp,
        comercialSMS: currentPatientEdit.comercialSMS,
        comercialPostal: currentPatientEdit.comercialPostal,
        comercialEmail: currentPatientEdit.comercialEmail,
        comercialTelefono: currentPatientEdit.comercialTelefono,
        aficiones: currentPatientEdit.aficiones,
        ametropias: currentPatientEdit.ametropias,
        observaciones: currentPatientEdit.observaciones,
      });
      // console.log("GUARDANDO DATOS PACIENTE: ", {
      // token: userData.token,
      // optica: selectedOptic.id,
      // idPaciente: patientId,
      // nif: currentPatientEdit.nif,
      // idNif: currentPatientEdit.idNif,
      // fidelizacion: currentPatientEdit.fidelizacion,
      // nombre: currentPatientEdit.nombre,
      // apellidos: currentPatientEdit.apellidos,
      // direccion: currentPatientEdit.direccion,
      // localidad: currentPatientEdit.localidad,
      // provincia: currentPatientEdit.provincia,
      // email: currentPatientEdit.email,
      // campana: currentPatientEdit.campana,
      // recomendado: currentPatientEdit.recomendado,
      // sexo: currentPatientEdit.sexo,
      // nacimiento: currentPatientEdit.nacimiento,
      // codigoPostal: currentPatientEdit.codigoPostal,
      // telefono: currentPatientEdit.telefono,
      // movil: currentPatientEdit.movil,
      // fax: currentPatientEdit.fax,
      // carnetConducir: currentPatientEdit.carnetConducir,
      // tieneHijos: currentPatientEdit.tieneHijos,
      // codigoRec: currentPatientEdit.codigoRec,
      // personaContactoCodigo: currentPatientEdit.personaContactoCodigo,
      // personaContactoNombre: currentPatientEdit.personaContactoNombre,
      // personaContactoTelefono: currentPatientEdit.personaContactoTelefono,
      // trabajoProfesion: currentPatientEdit.trabajoProfesion,
      // trabajoEmpresa: currentPatientEdit.trabajoEmpresa,
      // trabajoTelefono: currentPatientEdit.trabajoTelefono,
      // consentimientosRGPD: currentPatientEdit.consentimientosRGPD,
      // consentimientosAudiologia: currentPatientEdit.consentimientosAudiologia,
      // consentimientosLC: currentPatientEdit.consentimientosLC,
      // consentimientosORTOK: currentPatientEdit.consentimientosORTOK,
      // serviciosWhatsapp: currentPatientEdit.serviciosWhatsapp,
      // serviciosSMS: currentPatientEdit.serviciosSMS,
      // serviciosPostal: currentPatientEdit.serviciosPostal,
      // serviciosEmail: currentPatientEdit.serviciosEmail,
      // serviciosTelefono: currentPatientEdit.serviciosTelefono,
      // comercialWhatsapp: currentPatientEdit.comercialWhatsapp,
      // comercialSMS: currentPatientEdit.comercialSMS,
      // comercialPostal: currentPatientEdit.comercialPostal,
      // comercialEmail: currentPatientEdit.comercialEmail,
      // comercialTelefono: currentPatientEdit.comercialTelefono,
      // aficiones: currentPatientEdit.aficiones,
      // ametropias: currentPatientEdit.ametropias,
      // observaciones: currentPatientEdit.observaciones,
      // });
      setHeaderName(
        currentPatientEdit.nombre + " " + currentPatientEdit.apellidos,
      );
      setCurrentPatient(currentPatientEdit);
      return true;
    }
    return false;
  };

  const savePatientPic = async (img, imgName) => {
    const response = await post("SubirFotoPaciente.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: patientId,
      nombreFichero: img === avatarImg ? "" : imgName,
      imagen: img === avatarImg ? "" : img,
      idAgente: userData.id,
    });
    if (response.error !== "") {
      props.createPopupQuestion(
        response.error,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  };

  const openCamera = () => {
    setCameraActive(true);
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
        }
      })
      .catch((err) => {
        setCameraActive(false);
      });
  };

  const closeCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    setCameraActive(false);
  };

  const createBeforeSaving = async () => {
    if (currentPatientEdit.idPaciente === -1) {
      const responseId = await post("CrearPaciente.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      setPatientId(responseId.idPaciente);
      patientId = responseId.idPaciente;
      let patient = currentPatientEdit;
      patient.idPaciente = responseId.idPaciente;
      setCurrentPatientEdit(patient);
      setCurrentPatient(patient);
    }
  };

  let scrollTo = (id) => {
    const element = document.querySelectorAll("div.dashboard-options")[0];
    if (element) {
      const el = document.querySelector(id);
      if (el) {
        let scrollDiv = el.offsetTop;
        element.scrollTo({
          top: scrollDiv,
          behavior: "smooth",
        });
      }
    }
  };

  const getOptometryHistory = async (pId) => {
    if (pId) {
      const response = await post("ListarHistoricoOptometrias.php", {
        token: userData.token,
        idPaciente: pId,
        optica: selectedOptic.id,
        completo: optometrySectionSeeMore ? 1 : 0,
      });
      setOptometryHistoryList(response);
    }
  };

  const getAudiometryHistory = async (pId) => {
    const response = await post("ListarHistoricoAudiometrias.php", {
      token: userData.token,
      idPaciente: pId,
      optica: selectedOptic.id,
      completo: audiometrySectionSeeMore ? 1 : 0,
    });
    setAudiometryHistoryList(response);
  };

  const getGlassesHistory = async (pId) => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaGafas.php",
      {
        token: userData.token,
        idPaciente: pId,
        completo: glassesSectionSeeMore ? 1 : 0,
      },
    );
    setGlassesHistoryList(response);
  };

  const getHearingAidsHistory = async (pId) => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaAudifonos.php",
      {
        token: userData.token,
        idPaciente: pId,
        completo: hearingAidsSeeMore ? 1 : 0,
      },
    );
    setHearingAidsHistoryList(response);
  };

  const getCLHistory = async (pId) => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaLentillas.php",
      {
        token: userData.token,
        idPaciente: pId,
        completo: CLSeeMore ? 1 : 0,
      },
    );
    setCLHistoryList(response);
  };

  const getNumOptometries = async (pId) => {
    const response = await post("ListarNumOptometrias.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: pId,
    });
    setNumOptometries(response);
    setRecentOptometryIds({
      optometria: response.optometria.id,
      anamnesis: response.anamnesis.id,
      refractivo: response.refractivo.id,
      oculomotor: response.oculomotor.id,
      binocular: response.binocular.id,
      acomodativo: response.acomodativo.id,
      sensorial: response.sensorial.id,
      saludOcular: response.saludOcular.id,
    });
  };

  const closeOptoPanel = async (props) => {
    props.closeOptoPanel();
    await getOptometryHistory(patientId);
    await getNumOptometries(patientId);
  };

  const closeAudiometryPanel = async (props) => {
    props.closeAudiometryPanel();
    await getAudiometryHistory(patientId);
  };

  const closeGlassesPanel = async (props) => {
    props.closeGlassesPanel();
    await getGlassesHistory(patientId);
    await getNumSC(patientId);
  };

  const closeHearingAidsPanel = async (props) => {
    props.closeHearingAidsPanel();
    await getHearingAidsHistory(patientId);
    await getNumSC(patientId);
  };

  const closeCLPanel = async (props) => {
    props.closeContactLensesPanel();
    await getCLHistory(patientId);
    await getNumSC(patientId);
  };

  const openOptoPanelForNewOpto = () => {
    let aux = recentOptometryIds;
    aux.optometria = -1;
    props.openOptoPanel(
      {
        id: patientId,
        name: currentPatient.nombre + " " + currentPatient.apellidos,
        birthDate: currentPatientEdit.nacimiento,
      },
      0,
      aux,
      () => {
        closeOptoPanel(props);
      },
    );
  };

  const openAudioPanelForNewAudio = () => {
    props.openAudiometryPanel(
      {
        id: patientId,
        name: currentPatient.nombre + " " + currentPatient.apellidos,
        openPanel: false,
      },
      -1,
      async () => {
        await closeAudiometryPanel(props);
      },
    );
  };

  const openPanelForNewGlasses = () => {
    props.openGlassesPanel(
      {
        id: patientId,
        name: currentPatient.nombre + " " + currentPatient.apellidos,
      },
      -1,
      async () => {
        await closeGlassesPanel(props);
      },
    );
  };

  const openPanelForNewLenses = () => {
    props.openContactLensesPanel(
      {
        id: patientId,
        name: currentPatient.nombre + " " + currentPatient.apellidos,
        openPanel: false,
      },
      -1,
      async () => {
        await closeCLPanel(props);
      },
    );
  };

  const openPanelForNewHearingAid = () => {
    props.openHearingAidsPanel(
      {
        id: patientId,
        name: currentPatient.nombre + " " + currentPatient.apellidos,
      },
      -1,
      async () => {
        await closeHearingAidsPanel(props);
      },
    );
  };

  const checkDuplicateAndProceed = async (proceed) => {
    const result = await post("ComprobarDuplicadoPaciente.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: currentPatientEdit.idPaciente,
      dni: currentPatientEdit.nif,
      nombre: currentPatientEdit.nombre,
      apellidos: currentPatientEdit.apellidos,
    });
    const hasDNIDup = result?.duplicadoDNI && result.duplicadoDNI !== "";
    const hasNombreDup =
      result?.duplicadoNombre && result.duplicadoNombre !== "";

    if (hasDNIDup || hasNombreDup) {
      const dup = hasDNIDup ? result.duplicadoDNI : result.duplicadoNombre;
      const edadCreando = calculateAge(currentPatientEdit.nacimiento);
      const telefonosCreando = [
        currentPatientEdit.telefono,
        currentPatientEdit.movil,
      ]
        .filter(Boolean)
        .join(", ");
      const message = (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <span>
            {hasDNIDup
              ? "Atención. Se ha encontrado paciente con mismo DNI."
              : "Atención. Se han encontrado los siguientes pacientes duplicados."}
          </span>
          <DataTable
            columns={[
              {
                name: "DNI",
                selector: (row) => row.dni,
                sortable: true,
              },
              {
                name: "Nombre",
                selector: (row) => row.nombre,
                sortable: true,
              },
              {
                name: "Edad",
                selector: (row) => row.edad,
                sortable: true,
              },
              {
                name: "Teléfonos",
                selector: (row) => row.telefonos,
                sortable: true,
              },
              {
                name: "Dirección",
                selector: (row) => row.direccion,
                sortable: true,
              },
              {
                name: "Estado",
                selector: (row) => row.estado,
                sortable: true,
              },
            ]}
            data={[
              {
                dni: dup.dni,
                nombre: `${dup.nombre} ${dup.apellidos}`,
                edad: dup.edad,
                telefonos: dup.telefonos,
                direccion: dup.direccion,
                estado: "EXISTENTE",
              },
              {
                dni: currentPatientEdit.nif,
                nombre: `${currentPatientEdit.nombre} ${currentPatientEdit.apellidos}`,
                edad: edadCreando,
                telefonos: telefonosCreando,
                direccion: currentPatientEdit.direccion,
                estado: "CREANDO",
              },
            ]}
            className="custom-datatable"
            noDataComponent="No hay pacientes duplicados."
          />
        </div>
      );
      if (hasDNIDup) {
        props.createPopupQuestion(
          message,
          props.removePopupQuestion,
          null,
          "Cancelar",
        );
      } else {
        props.createPopupQuestion(
          message,
          async () => {
            props.removePopupQuestion();
            await proceed();
          },
          () => {
            props.removePopupQuestion();
            props.onClickMenuOption("patient-datos", { patientId: dup.id });
          },
          "Guardar paciente",
          "Abrir existente",
          props.removePopupQuestion,
          "Cancelar",
        );
      }
    } else {
      await proceed();
    }
  };

  const onChangeScreen = async (onOk) => {
    const bypassing = cancellingCreationRef.current;
    cancellingCreationRef.current = false;
    if (
      !bypassing &&
      (patientDataChanges || currentPatientEdit.idPaciente === -1)
    ) {
      props.createPopupQuestion(
        `Existen cambios sin guardar en la ficha del paciente actual${
          currentPatient.idPaciente !== -1
            ? ` (${currentPatient.nombre + " " + currentPatient.apellidos})`
            : ``
        }. ¿Desea guardar los cambios antes de cambiar de pantalla?`,
        async () => {
          if (patientReadyToSave) {
            await checkDuplicateAndProceed(async () => {
              if (currentPatientEdit.idPaciente === -1) {
                await createBeforeSaving();
              }
              const saved = await savePatientData();
              if (!saved) {
                return;
              }
              props.removePopupQuestion();
              setForceReload(false);
              onOk();
            });
          } else {
            popUpIncompleteData();
          }
        },
        () => {
          setCurrentPatientEdit(currentPatient);
          props.removePopupQuestion();
          setForceReload(false);
          onOk();
        },
        "Sí",
        "No",
        () => {
          props.removePopupQuestion();
        },
        "Cancelar",
      );
    } else {
      setForceReload(false);
      setLoadingPatient(true);
      onOk();
    }
  };

  async function getNumSC(id) {
    const response = await post("/support-extra/cesta/ObtenerCesta.php", {
      token: userData.token,
      idPaciente: id,
      idOptica: selectedOptic.id,
    });
    setNumSC(response.length);
  }

  function isDisabled() {
    return patientId === -1;
  }

  function popUpIncompleteData() {
    props.createPopupQuestion(
      `Debe rellenar al menos el nombre del paciente.`,
      () => {
        if (currentPatientEdit.nombre === "") focusElement(3);
        props.removePopupQuestion();
      },
      null,
      "Entendido",
    );
  }

  const onClickNewSale = () => {
    if (currentPatientEdit.idPaciente !== -1) {
      props.onClickMenuOption("venta", {
        saleId: -1,
        orderPatientId: patientId,
      });
    }
  };

  const showNoPrintDataPopup = () => {
    props.createPopupQuestion(
      "No se encuentran datos para imprimir.",
      () => {
        props.removePopupQuestion();
      },
      null,
      "Entendido",
    );
  };

  const exportComprasReport = async (format) => {
    if (!salesExportData) return;

    const {
      sales,
      numSales,
      totalSales,
      numReturns,
      totalReturns,
      totalPending,
    } = salesExportData;

    const tables = sales.map((sale) => ({
      titulosTabla: [],
      numReferencias: "",
      extraCabeceras: [
        {
          titulo: "Fecha",
          descripcion: moment(sale.date).format("DD/MM/YYYY"),
        },
        { titulo: "Óptica", descripcion: sale.opticName },
        { titulo: "Realizada Por", descripcion: sale.soldBy },
        {
          titulo: "Motivo",
          descripcion: sale.campaign === "" ? "-" : sale.campaign,
        },
        { titulo: "Tipo", descripcion: sale.type },
        { titulo: "Total", descripcion: formatCurrency(sale.total) },
        { titulo: "Abono", descripcion: formatCurrency(sale.paid) },
        { titulo: "Pendiente", descripcion: formatCurrency(sale.pending) },
      ],
      cabeceras: [
        { titulo: "Código", tipo: "string", sumatorio: false },
        {
          titulo: "Descripción del producto",
          tipo: "string",
          sumatorio: false,
        },
        { titulo: "PVP", tipo: "currency", sumatorio: false },
        { titulo: "Dto", tipo: "perc", sumatorio: false },
        { titulo: "IVA", tipo: "perc", sumatorio: false },
        { titulo: "PVU", tipo: "currency", sumatorio: false },
        { titulo: "Uds", tipo: "int", sumatorio: false },
        { titulo: "Total", tipo: "currency", sumatorio: false },
      ],
      filas: sale.lines.map((line) => [
        line.code,
        line.description,
        formatCurrency(line.pvp),
        Math.round(parseFloat(line.porcDto) || 0) + " %",
        line.porcIVA + " %",
        formatCurrency(line.pvu),
        line.uds,
        formatCurrency(line.total),
      ]),
    }));

    await exportToFile(
      `Compras Paciente ${currentPatient.nombre} ${currentPatient.apellidos} (${currentPatientEdit.codigo})`,
      [
        `Ventas (${numSales}): ${formatCurrency(totalSales)}`,
        `Devoluciones (${numReturns}): ${formatCurrency(totalReturns)}`,
        `Pendiente: ${formatCurrency(totalPending)}`,
      ],
      false,
      false,
      format,
      tables,
      -1,
      "",
    );
  };

  const formatOptValue = (value, sign) => {
    if (value === "") {
      return "-";
    }
    return value > 0 && sign ? `+${value}` : value;
  };

  const exportOptometriasReport = async (format) => {
    if (!optometryHistoryList || optometryHistoryList.length === 0) return;

    const tables = optometryHistoryList.map((opt) => ({
      titulosTabla: [],
      numReferencias: "",
      extraCabeceras: [
        {
          titulo: "Fecha",
          descripcion: moment(opt.fecha).format("DD/MM/YYYY HH:mm:ss"),
        },
        {
          titulo: "Realizada por",
          descripcion: opt.realizadaPor !== "" ? opt.realizadaPor : "-",
        },
        {
          titulo: "Tipo",
          descripcion: opt.tipo === "LC" ? "L. Contacto" : opt.tipo,
        },
      ],
      cabeceras: [
        { titulo: "", tipo: "string", sumatorio: false },
        { titulo: "ESF", tipo: "string", sumatorio: false },
        { titulo: "CIL", tipo: "string", sumatorio: false },
        { titulo: "EJE", tipo: "string", sumatorio: false },
        { titulo: "AV lejos", tipo: "string", sumatorio: false },
        { titulo: "ADD", tipo: "string", sumatorio: false },
        { titulo: "Cerca", tipo: "string", sumatorio: false },
        { titulo: "AV cerca", tipo: "string", sumatorio: false },
      ],
      filas: [
        [
          "OD",
          formatOptValue(opt.esfera_d, true),
          formatOptValue(opt.cilindro_d, true),
          formatOptValue(opt.eje_d, false),
          formatOptValue(opt.av_cc_lejos_d, false),
          formatOptValue(opt.cerca_d, true),
          formatOptValue(opt.total_d, true),
          formatOptValue(opt.av_cc_cerca_d, false),
        ],
        [
          "OI",
          formatOptValue(opt.esfera_i, true),
          formatOptValue(opt.cilindro_i, true),
          formatOptValue(opt.eje_i, false),
          formatOptValue(opt.av_cc_lejos_i, false),
          formatOptValue(opt.cerca_i, true),
          formatOptValue(opt.total_i, true),
          formatOptValue(opt.av_cc_cerca_i, false),
        ],
      ],
    }));

    await exportToFile(
      `OPTOMETRíAS PACIENTE ${currentPatient.nombre} ${currentPatient.apellidos} (${currentPatientEdit.codigo})`,
      [],
      false,
      false,
      format,
      tables,
      -1,
      "",
    );
  };

  const exportGlassesReport = async (format) => {
    if (!glassesHistoryList || glassesHistoryList.length === 0) return;

    const tables = glassesHistoryList.flatMap((data) => {
      const totalExtras = data.extras.reduce(
        (acc, extra) => acc + (parseFloat(extra.total) || 0),
        0,
      );

      return [
        {
          titulosTabla: [
            `Tipo: ${data.gafasSol ? "Sol" : "Vista"}`,
            `Fecha: ${moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}`,
            `Realizada por: ${data.empleado}`,
            `Tipo Ficha: ${data.tipoFichaDescripcion}`,
            `Tipo gafa: ${data.tipoGafaDescripcion}`,
            `Total ficha: ${formatCurrency(data.precioTotal)}`,
          ],
          numReferencias: "",
          extraCabeceras: [],
          cabeceras: [],
          filas: [],
        },
        {
          titulosTabla: [],
          numReferencias: "",
          extraCabeceras: [
            { titulo: "Montura", descripcion: "" },
            {
              titulo: "Proveedor",
              descripcion: data.datosMontura.nombreProveedor,
            },
            { titulo: "Código", descripcion: data.datosMontura.codigo },
            {
              titulo: "Total",
              descripcion: formatCurrency(data.datosMontura.total),
            },
          ],
          cabeceras: [
            { titulo: "Marca", tipo: "string", sumatorio: false },
            { titulo: "Modelo", tipo: "string", sumatorio: false },
            { titulo: "Color", tipo: "string", sumatorio: false },
            { titulo: "Color lente", tipo: "string", sumatorio: false },
            { titulo: "Calibre", tipo: "int", sumatorio: false },
            { titulo: "Puente", tipo: "int", sumatorio: false },
            { titulo: "Varilla", tipo: "int", sumatorio: false },
            { titulo: "Material", tipo: "string", sumatorio: false },
            { titulo: "Forma", tipo: "string", sumatorio: false },
          ],
          filas: [
            [
              data.datosMontura.marca,
              data.datosMontura.modelo,
              data.datosMontura.color,
              data.datosMontura.colorCristal,
              data.datosMontura.calibre1,
              data.datosMontura.calibre2,
              data.datosMontura.varilla,
              data.datosMontura.material,
              data.datosMontura.forma,
            ],
          ],
        },
        {
          titulosTabla: [],
          numReferencias: "",
          extraCabeceras: [
            { titulo: "Lente OD", descripcion: "" },
            {
              titulo: "Proveedor",
              descripcion: data.datosLenteOD.nombreProveedor,
            },
            { titulo: "Código", descripcion: data.datosLenteOD.codigo },
            {
              titulo: "Total",
              descripcion: formatCurrency(data.datosLenteOD.total),
            },
          ],
          cabeceras: [
            { titulo: "Marca", tipo: "string", sumatorio: false },
            { titulo: "Nombre comercial", tipo: "string", sumatorio: false },
            { titulo: "Material", tipo: "string", sumatorio: false },
            { titulo: "Tipo", tipo: "string", sumatorio: false },
            { titulo: "Color", tipo: "string", sumatorio: false },
            { titulo: "Tratamiento", tipo: "string", sumatorio: false },
          ],
          filas: [
            [
              data.datosLenteOD.marca,
              data.datosLenteOD.nombreComercial,
              data.datosLenteOD.material,
              data.datosLenteOD.tipo,
              data.datosLenteOD.color,
              data.datosLenteOD.tratamiento,
            ],
          ],
        },
        {
          titulosTabla: [],
          numReferencias: "",
          extraCabeceras: [
            { titulo: "Lente OI", descripcion: "" },
            {
              titulo: "Proveedor",
              descripcion: data.datosLenteOI.nombreProveedor,
            },
            { titulo: "Código", descripcion: data.datosLenteOI.codigo },
            {
              titulo: "Total",
              descripcion: formatCurrency(data.datosLenteOI.total),
            },
          ],
          cabeceras: [
            { titulo: "Marca", tipo: "string", sumatorio: false },
            { titulo: "Nombre comercial", tipo: "string", sumatorio: false },
            { titulo: "Material", tipo: "string", sumatorio: false },
            { titulo: "Tipo", tipo: "string", sumatorio: false },
            { titulo: "Color", tipo: "string", sumatorio: false },
            { titulo: "Tratamiento", tipo: "string", sumatorio: false },
          ],
          filas: [
            [
              data.datosLenteOI.marca,
              data.datosLenteOI.nombreComercial,
              data.datosLenteOI.material,
              data.datosLenteOI.tipo,
              data.datosLenteOI.color,
              data.datosLenteOI.tratamiento,
            ],
          ],
        },
        ...(data.extras.length > 0
          ? [
              {
                titulosTabla: [],
                numReferencias: "",
                extraCabeceras: [
                  { titulo: "Extras", descripcion: "" },
                  {
                    titulo: "Total extras",
                    descripcion: formatCurrency(totalExtras),
                  },
                ],
                cabeceras: [
                  { titulo: "Código", tipo: "string", sumatorio: false },
                  { titulo: "Descripción", tipo: "string", sumatorio: false },
                  { titulo: "Total", tipo: "currency", sumatorio: false },
                ],
                filas: data.extras.map((e) => [
                  e.codigo,
                  e.descripcion,
                  formatCurrency(e.total),
                ]),
              },
            ]
          : []),
      ];
    });

    await exportToFile(
      `Fichas de Gafas Paciente ${currentPatient.nombre} ${currentPatient.apellidos} (${currentPatientEdit.codigo})`,
      [],
      false,
      false,
      format,
      tables,
      -1,
      "",
    );
  };

  const exportContactLensesReport = async (format) => {
    if (!CLHistoryList || CLHistoryList.length === 0) return;

    const CLLensCabeceras = [
      { titulo: "Nombre comercial", tipo: "string", sumatorio: false },
      { titulo: "Tipo", tipo: "string", sumatorio: false },
      { titulo: "Uso", tipo: "string", sumatorio: false },
      { titulo: "Esf", tipo: "string", sumatorio: false },
      { titulo: "Cil", tipo: "string", sumatorio: false },
      { titulo: "Eje", tipo: "int", sumatorio: false },
      { titulo: "Add", tipo: "string", sumatorio: false },
      { titulo: "Total", tipo: "string", sumatorio: false },
      { titulo: "Rad", tipo: "string", sumatorio: false },
      { titulo: "Rad2", tipo: "string", sumatorio: false },
      { titulo: "Diá", tipo: "float", sumatorio: false },
    ];

    const formatOptoFloat = (value) =>
      value === "" || value === null || value === undefined
        ? ""
        : reformatField(String(value), "type-optofloat");

    const CLLensFilas = (lens) => [
      [
        lens.nombreComercial,
        lens.tipo,
        lens.uso,
        formatOptoFloat(lens.esf),
        formatOptoFloat(lens.cil),
        lens.eje,
        formatOptoFloat(lens.add),
        formatOptoFloat(lens.total),
        lens.rad,
        lens.rad2,
        lens.dia,
      ],
    ];

    const tables = CLHistoryList.flatMap((data) => [
      {
        titulosTabla: [
          `Fecha: ${moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}`,
          `Realizada por: ${data.empleado}`,
          `Pruebas realizadas: ${data.numPruebas}`,
          `Total ficha: ${formatCurrency(data.totalFicha)}`,
        ],
        numReferencias: "",
        extraCabeceras: [],
        cabeceras: [],
        filas: [],
      },
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [
          { titulo: "Lente de contacto OD", descripcion: "" },
          {
            titulo: "Total",
            descripcion: formatCurrency(data.OD.totalPrecio),
          },
        ],
        cabeceras: CLLensCabeceras,
        filas: CLLensFilas(data.OD),
      },
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [
          { titulo: "Lente de contacto OI", descripcion: "" },
          {
            titulo: "Total",
            descripcion: formatCurrency(data.OI.totalPrecio),
          },
        ],
        cabeceras: CLLensCabeceras,
        filas: CLLensFilas(data.OI),
      },
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [
          { titulo: "Líquido", descripcion: "" },
          { titulo: "Total", descripcion: formatCurrency(data.liquido.total) },
        ],
        cabeceras: [
          { titulo: "Proveedor", tipo: "string", sumatorio: false },
          { titulo: "Marca", tipo: "string", sumatorio: false },
          { titulo: "Nombre comercial", tipo: "string", sumatorio: false },
        ],
        filas: [
          [
            data.liquido.proveedor || "-",
            data.liquido.marca || "-",
            data.liquido.nombreComercial || "-",
          ],
        ],
      },
    ]);

    await exportToFile(
      `Fichas de Lentes de Contacto Paciente ${currentPatient.nombre} ${currentPatient.apellidos} (${currentPatientEdit.codigo})`,
      [],
      false,
      false,
      format,
      tables,
      -1,
      "",
    );
  };

  const exportHearingAidsReport = async (format) => {
    if (!hearingAidsHistoryList || hearingAidsHistoryList.length === 0) return;

    const HACabeceras = [
      { titulo: "Proveedor", tipo: "string", sumatorio: false },
      { titulo: "Código", tipo: "string", sumatorio: false },
      { titulo: "Nº Serie", tipo: "string", sumatorio: false },
      { titulo: "Marca", tipo: "string", sumatorio: false },
      { titulo: "Modelo", tipo: "string", sumatorio: false },
      { titulo: "Tipo", tipo: "string", sumatorio: false },
      { titulo: "Rango dB", tipo: "string", sumatorio: false },
      { titulo: "Auricular", tipo: "string", sumatorio: false },
      { titulo: "Cód. Auricular", tipo: "string", sumatorio: false },
      { titulo: "Pila", tipo: "string", sumatorio: false },
      { titulo: "Cód. Pila", tipo: "string", sumatorio: false },
    ];

    const HAFilas = (audifono) => [
      [
        audifono.proveedor,
        audifono.codigo,
        audifono.nSerie,
        audifono.marca,
        audifono.modelo,
        audifono.tipo,
        `${audifono.entreDb || "-"} - ${audifono.hastaDb || "-"}`,
        audifono.auricular,
        audifono.codigoAuricular,
        audifono.pila,
        audifono.codigoPila,
      ],
    ];

    const tables = hearingAidsHistoryList.flatMap((data) => [
      {
        titulosTabla: [
          `Fecha: ${moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}`,
          `Realizada por: ${data.empleado}`,
          `Total ficha: ${formatCurrency(data.totalFicha)}`,
        ],
        numReferencias: "",
        extraCabeceras: [],
        cabeceras: [],
        filas: [],
      },
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [
          { titulo: "Audífono derecho", descripcion: "" },
          {
            titulo: "Total",
            descripcion: formatCurrency(data.datosAudifonoD.total),
          },
        ],
        cabeceras: HACabeceras,
        filas: HAFilas(data.datosAudifonoD),
      },
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [
          { titulo: "Audífono izquierdo", descripcion: "" },
          {
            titulo: "Total",
            descripcion: formatCurrency(data.datosAudifonoI.total),
          },
        ],
        cabeceras: HACabeceras,
        filas: HAFilas(data.datosAudifonoI),
      },
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [
          { titulo: "Cargador", descripcion: "" },
          {
            titulo: "Total",
            descripcion: formatCurrency(data.cargador.total),
          },
        ],
        cabeceras: [
          { titulo: "Proveedor", tipo: "string", sumatorio: false },
          { titulo: "Código", tipo: "string", sumatorio: false },
          { titulo: "Marca", tipo: "string", sumatorio: false },
          { titulo: "Modelo", tipo: "string", sumatorio: false },
        ],
        filas: [
          [
            data.cargador.proveedor,
            data.cargador.codigo,
            data.cargador.marca,
            data.cargador.modelo,
          ],
        ],
      },
    ]);

    await exportToFile(
      `Fichas de Audífonos Paciente ${currentPatient.nombre} ${currentPatient.apellidos} (${currentPatientEdit.codigo})`,
      [],
      false,
      false,
      format,
      tables,
      -1,
      "",
    );
  };

  const exportAudiometryReport = async (format) => {
    if (!audiometryHistoryList || audiometryHistoryList.length === 0) return;

    const AUDIOMETRY_FREQS = [
      125, 250, 500, 1000, 1500, 2000, 3000, 4000, 6000, 8000,
    ];

    const audiometryCabeceras = [
      { titulo: "Hz", tipo: "string", sumatorio: false },
      ...AUDIOMETRY_FREQS.map((f) => ({
        titulo: `${f}`,
        tipo: "int",
        sumatorio: false,
      })),
    ];

    const buildEarTable = (data, side, titulo) => ({
      titulosTabla: [],
      numReferencias: "",
      extraCabeceras: [{ titulo, descripcion: "" }],
      cabeceras: audiometryCabeceras,
      filas: [
        ["Aérea", ...AUDIOMETRY_FREQS.map((f) => data[`aerea_${side}_${f}`])],
        ["Ósea", ...AUDIOMETRY_FREQS.map((f) => data[`osea_${side}_${f}`])],
        ["Umbral", ...AUDIOMETRY_FREQS.map((f) => data[`umbral_${side}_${f}`])],
      ],
    });

    const tables = audiometryHistoryList.flatMap((data) => [
      {
        titulosTabla: [
          `Fecha: ${moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}`,
          `Realizada por: ${data.audioprotesista}`,
        ],
        numReferencias: "",
        extraCabeceras: [],
        cabeceras: [],
        filas: [],
      },
      buildEarTable(data, "d", "Oído derecho"),
      buildEarTable(data, "i", "Oído izquierdo"),
    ]);

    await exportToFile(
      `Fichas de Audiometría Paciente ${currentPatient.nombre} ${currentPatient.apellidos} (${currentPatientEdit.codigo})`,
      [],
      false,
      false,
      format,
      tables,
      -1,
      "",
    );
  };

  const openCashVoucherPopup = (show) => {
    setShowCashVoucherPopup(show);
  };

  const onChangeNumCashVouchers = (num) => {
    setNumCashVouchers(num);
  };

  const loadOpticConfig = async () => {
    const response = await rpost("ventas/ObtenerConfiguracionOpticaVenta.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
    });
    const opticConfigN = {
      idFidelizacion: response.idFidelizacion ?? "",
      confTicketDobleCopiaVenta: response.confTicketDobleCopiaVenta,
      controlSanitario: response.controlSanitario,
      localidadOptica: response.localidadOptica ?? "",
      provinciaOptica: response.provinciaOptica ?? "",
    };
    setOpticConfig(opticConfigN);
    return opticConfigN;
  };

  const openLoyaltyPopup = (show) => {
    if (
      show &&
      (opticConfig.idFidelizacion === "" || opticConfig.idFidelizacion === -1)
    ) {
      props.createPopupQuestion(
        "La óptica no tiene perfil de fidelización.",
        props.removePopupQuestion,
        null,
        "Entendido",
      );
      return;
    }
    setShowLoyaltyPopup(show);
  };

  const openSendSMSPopup = (show) => {
    if (show && currentPatientEdit.movil === "") {
      props.createPopupQuestion(
        "El paciente no tienen ningún Móvil asignado.",
        props.removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    setShowSendSMSPopup(show);
  };

  const updateLoyaltyPoints = (points) => {
    let patient = currentPatientEdit;
    patient.puntos = points;
    setCurrentPatientEdit(patient);
  };

  const updatePatientDto = (dto) => {
    let patient = currentPatientEdit;
    patient.descuentoEspecial = dto;
    setCurrentPatientEdit(patient);
  };

  const generateWarrantyLetter = async () => {
    const response = await post(
      "/support-extra/gestionDocumental/GenerarDocumentoCartaGarantia.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: currentPatientEdit.idPaciente,
        agente: userData.nombre + " " + userData.apellidos,
      },
    );
    // console.log(
    // "GENERANDO CARTA GARANTÍA: ",
    // {
    // token: userData.token,
    // idOptica: selectedOptic.id,
    // idPaciente: currentPatientEdit.idPaciente,
    // agente: userData.nombre + " " + userData.apellidos,
    // },
    // response,
    // );
    if (response.error !== "") {
      props.createPopupQuestion(
        response.error,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `Carta_Garantía_${currentPatientEdit.nombre + "_" + currentPatientEdit.apellidos}.pdf`;
      a.click();
    }
  };

  const generateAttendanceCertificate = async () => {
    const response = await post(
      "/support-extra/gestionDocumental/GenerarDocumentoJustificanteAsistencia.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: currentPatientEdit.idPaciente,
        agente: userData.nombre + " " + userData.apellidos,
      },
    );
    // console.log(
    // "GENERANDO JUSTIFICANTE ASISTENCIA: ",
    // {
    // token: userData.token,
    // idOptica: selectedOptic.id,
    // idPaciente: currentPatientEdit.idPaciente,
    // agente: userData.nombre + " " + userData.apellidos,
    // },
    // response,
    // );
    if (response.error !== "") {
      props.createPopupQuestion(
        response.error,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `Justificante_Asistencia_${currentPatientEdit.nombre + "_" + currentPatientEdit.apellidos}.pdf`;
      a.click();
    }
  };

  const getPatientConsent = async (id) => {
    const response = await post("ObtenerConsentimientosPaciente.php", {
      token: userData.token,
      idPaciente: id,
      optica: selectedOptic.id,
    });
    // console.log(
    // "OBTENIENDO CONSENTIMIENTOS: ",
    // {
    // token: userData.token,
    // idPaciente: id,
    // optica: selectedOptic.id,
    // },
    // response,
    // );
    const consentFields = [
      "consentimientosRGPD",
      "consentimientosAudiologia",
      "consentimientosLC",
      "consentimientosORTOK",
      "serviciosWhatsapp",
      "serviciosSMS",
      "serviciosPostal",
      "serviciosEmail",
      "serviciosTelefono",
      "comercialWhatsapp",
      "comercialSMS",
      "comercialPostal",
      "comercialEmail",
      "comercialTelefono",
    ];
    const hasChanges = consentFields.some(
      (f) => currentPatientEdit[f] !== response[f],
    );
    if (!hasChanges) return;
    else {
      props.createPopupQuestion(
        "Se han actualizado los consentimientos de la ficha del paciente. Recuerde guardar la ficha antes de continuar.",
        () => {
          setConsentChanges(false);
          setCurrentPatientEdit((prev) => ({
            ...prev,
            ...Object.fromEntries(consentFields.map((f) => [f, response[f]])),
          }));
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  };

  const checkConsentChanges = (data) => {
    const fields = [
      "comercialEmail",
      "comercialPostal",
      "comercialSMS",
      "comercialTelefono",
      "comercialWhatsapp",
      "serviciosEmail",
      "serviciosPostal",
      "serviciosSMS",
      "serviciosTelefono",
      "serviciosWhatsapp",
    ];
    const hasChanges = fields.some((f) => data[f] !== currentPatientEdit[f]);
    if (hasChanges) {
      setCurrentPatientEdit((prev) => ({
        ...prev,
        ...Object.fromEntries(fields.map((f) => [f, data[f]])),
      }));
    }
    setConsentChanges(hasChanges);
  };

  useEffect(() => {
    setPatientDataChanges(
      JSON.stringify(currentPatient) !== JSON.stringify(currentPatientEdit),
    );
    if (props.newOptometry) {
      openOptoPanelForNewOpto();
    }
    if (props.newAudiometry) {
      openAudioPanelForNewAudio();
    }
    if (props.newGlasses) {
      openPanelForNewGlasses();
    }
    if (props.newLenses) {
      openPanelForNewLenses();
    }
    if (props.newHearingAid) {
      openPanelForNewHearingAid();
    }
  }, [
    currentPatient,
    currentPatientEdit,
    props.newOptometry,
    props.newAudiometry,
    props.newGlasses,
    props.newLenses,
    props.newHearingAid,
  ]);

  useEffect(() => {
    const loadData = async () => {
      if (props.patientId) {
        const opticConfigPromise = loadOpticConfig();
        if (props.patientId === -1) {
          setPatientId(-1);
          await createPatient(await opticConfigPromise);
          setNumObservations(0);
          focusElement(1);
        } else {
          setPatientId(props.patientId);
          await getPatientData(props.patientId);
          await getPatientPicture(props.patientId);
        }
      }
      if (props.show === true) {
        focusElement(props.patientId === -1 ? 1 : 0);
      }
    };
    loadData();
  }, [props.patientId, selectedOptic, forceReload, props.show]);

  useEffect(() => {
    if (props.show && !loadingPatient) {
      setTimeout(() => {
        focusElement(props.patientId === -1 ? 1 : 0);
      }, 0);
    }
  }, [props.show, loadingPatient, props.patientId]);

  useEffect(() => {
    const allCommercialCheckboxesChecked = [
      currentPatientEdit.comercialEmail,
      currentPatientEdit.comercialTelefono,
      currentPatientEdit.comercialPostal,
      currentPatientEdit.comercialSMS,
      currentPatientEdit.comercialWhatsapp,
    ].some(Boolean);
    const allServicesCheckboxesChecked = [
      currentPatientEdit.serviciosEmail,
      currentPatientEdit.serviciosTelefono,
      currentPatientEdit.serviciosPostal,
      currentPatientEdit.serviciosSMS,
      currentPatientEdit.serviciosWhatsapp,
    ].some(Boolean);

    setCheckboxState({
      ...checkboxState,
      checkboxCommercial: allCommercialCheckboxesChecked,
      checkboxServices: allServicesCheckboxesChecked,
    });
  }, [
    currentPatientEdit.comercialEmail,
    currentPatientEdit.comercialTelefono,
    currentPatientEdit.comercialPostal,
    currentPatientEdit.comercialSMS,
    currentPatientEdit.comercialWhatsapp,
    currentPatientEdit.serviciosEmail,
    currentPatientEdit.serviciosTelefono,
    currentPatientEdit.serviciosPostal,
    currentPatientEdit.serviciosSMS,
    currentPatientEdit.serviciosWhatsapp,
  ]);

  useEffect(() => {
    if (identityNumberTypes) {
      const popupContainer = document.createElement("div");
      popupContainer.id = "popupContainer";

      const root = createRoot(popupContainer);

      root.render(
        <PopupNIFTypes
          idNif={currentPatientEdit.idNif}
          onClick={() => setIdentityNumberTypes(false)}
          onAccept={(e) => {
            setCurrentPatientEdit({
              ...currentPatientEdit,
              idNif: e.idNif,
              tipoNif: e.description,
            });
          }}
        />,
      );

      const rootElement = document.getElementById("root");

      if (rootElement) {
        const firstChild = rootElement.firstChild;
        rootElement.insertBefore(popupContainer, firstChild);
      }
    } else {
      const popupContainer = document.getElementById("popupContainer");
      if (popupContainer) {
        popupContainer.remove();
      }
    }
  }, [identityNumberTypes, currentPatientEdit.tipoNif]);

  useEffect(() => {
    if (cameraActive) {
      const popupContainer = document.createElement("div");
      popupContainer.id = "popupContainer";

      const root = createRoot(popupContainer);

      root.render(
        <WebCam
          videoRef={videoRef}
          canvasRef={canvasRef}
          photoRef={photoRef}
          onTakePhoto={async (e) => {
            setPatientPicture(e);
            setCameraActive(false);
            await savePatientPic(e, `foto-${Date.now()}.png`);
            closeCamera();
          }}
          onCancel={() => {
            setCameraActive(false);
            closeCamera();
          }}
        ></WebCam>,
      );

      const rootElement = document.getElementById("root");

      if (rootElement) {
        const firstChild = rootElement.firstChild;
        rootElement.insertBefore(popupContainer, firstChild);
      }
    } else {
      const popupContainer = document.getElementById("popupContainer");
      if (popupContainer) {
        popupContainer.remove();
      }
    }
  }, [cameraActive]);

  useEffect(() => {
    setPatientReadyToSave(currentPatientEdit.nombre !== "");
    const genericPictures = [
      "/images/avatar.svg",
      "/images/support-extra/hombre.svg",
      "/images/support-extra/mujer.svg",
    ];
    if (genericPictures.includes(patientPicture)) {
      if (currentPatientEdit.sexo === "HOMBRE") {
        setPatientPicture("/images/support-extra/hombre.svg");
      } else if (currentPatientEdit.sexo === "MUJER") {
        setPatientPicture("/images/support-extra/mujer.svg");
      } else {
        setPatientPicture("/images/avatar.svg");
      }
    }
  }, [currentPatientEdit]);

  useEffect(() => {
    getOptometryHistory(patientId);
  }, [optometrySectionSeeMore]);

  useEffect(() => {
    getAudiometryHistory(patientId);
  }, [audiometrySectionSeeMore]);

  useEffect(() => {
    getGlassesHistory(patientId);
  }, [glassesSectionSeeMore]);

  useEffect(() => {
    getHearingAidsHistory(patientId);
  }, [hearingAidsSeeMore]);

  useEffect(() => {
    getCLHistory(patientId);
  }, [CLSeeMore]);

  useEffect(() => {
    if (patientId) {
      getNumSC(patientId);
    }
  }, [patientId]);

  useEffect(() => {
    getNumSC(patientId);
  }, [props.showSC]);

  useEffect(() => {
    if (errorEmail) {
      props.createPopupQuestion(
        "Por favor, revise el email.",
        () => {
          focusElement(8);
          setErrorEmail(false);
          props.removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  }, [errorEmail]);

  useEffect(() => {
    if (errorCP) {
      props.createPopupQuestion(
        "Por favor, revise el código postal.",
        () => {
          focusElement(14);
          setErrorCP(false);
          props.removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  }, [errorCP]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        floatingMenu &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setFloatingMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [floatingMenu]);

  useEffect(() => {
    setSelectedDocumentType(
      documentTypesList.find((e) => e.idNif === currentPatientEdit.idNif) ?? {
        description: "NIF",
        documentId: "01",
        idNif: "00",
      },
    );
  }, [documentTypesList, currentPatientEdit.idNif]);

  if (!props.show) {
    return <></>;
  }

  if (loadingPatient) {
    return (
      <LoadingScreen message="Cargando ficha del paciente..."></LoadingScreen>
    );
  }

  return (
    <div className="patient-data">
      <span id="patient-id" style={{ display: "none" }}>
        {patientId}
      </span>
      <div className="patient-data-header">
        <span className="header-text">Paciente</span>
      </div>
      {handleGDPRConsent && (
        <GDPRConsent
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          patientData={{
            id: currentPatientEdit.idPaciente,
            nif: currentPatientEdit.nif,
            name:
              currentPatientEdit.nombre + " " + currentPatientEdit.apellidos,
          }}
          onClose={async (data) => {
            setHandleGDPRConsent(false);
            await getFilesDM(patientId);
            await getPatientConsent(patientId);
          }}
        />
      )}
      {handleLCConsent && (
        <LCConsent
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          patientData={{
            id: currentPatientEdit.idPaciente,
            nif: currentPatientEdit.nif,
            name:
              currentPatientEdit.nombre + " " + currentPatientEdit.apellidos,
          }}
          onClose={async () => {
            setHandleLCConsent(false);
            await getFilesDM(patientId);
            await getPatientConsent(patientId);
          }}
        />
      )}
      {handleORTHOKConsent && (
        <ORTHOKConsent
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          patientData={{
            id: currentPatientEdit.idPaciente,
            nif: currentPatientEdit.nif,
            name:
              currentPatientEdit.nombre + " " + currentPatientEdit.apellidos,
          }}
          onClose={async () => {
            setHandleORTHOKConsent(false);
            await getFilesDM(patientId);
            await getPatientConsent(patientId);
          }}
        />
      )}
      {handleAudioConsent && (
        <AudioConsent
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          patientData={{
            id: currentPatientEdit.idPaciente,
            nif: currentPatientEdit.nif,
            name:
              currentPatientEdit.nombre + " " + currentPatientEdit.apellidos,
          }}
          onClose={async () => {
            setHandleAudioConsent(false);
            await getFilesDM(patientId);
            await getPatientConsent(patientId);
          }}
        />
      )}
      {handleDocumentManagement && (
        <PatientDocumentManagement
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          patientData={{
            id: currentPatientEdit.idPaciente,
            nif: currentPatientEdit.nif,
            name:
              currentPatientEdit.nombre + " " + currentPatientEdit.apellidos,
          }}
          onClose={async () => {
            setHandleDocumentManagement(false);
            await getPatientConsent(patientId);
          }}
          onUpdate={(e) => {
            setNumFilesDM(e);
          }}
        />
      )}
      {existPatient && (
        <div className="patient-data-content">
          <div className="action-bar">
            <div className="action-bar-resume">
              <span>Pacientes</span>
              <span>|</span>
              <span>Búsqueda de pacientes</span>
              <span>|</span>
              <span className="signed-text">Resultado de búsqueda</span>
            </div>
          </div>
          <div className={`patient-info ${loadingPatient ? "hidden" : ""}`}>
            <div className="patient-info-row1">
              <div className="patient-info-1">
                <img
                  src={patientPicture}
                  loading="lazy"
                  alt="Patient img"
                  className="patient-img"
                />
                {patientPicture !== "/images/avatar.svg" &&
                  patientPicture !== "/images/support-extra/hombre.svg" &&
                  patientPicture !== "/images/support-extra/mujer.svg" && (
                    <>
                      <img
                        src="/images/remove.svg"
                        loading="lazy"
                        data-tooltip-id="ttdeletepic"
                        alt="Icon"
                        className="small-icon delete-icon"
                        onClick={() => {
                          props.createPopupQuestion(
                            `¿Desea eliminar la foto del paciente?`,
                            async () => {
                              await deletePatientPicture();
                              props.removePopupQuestion();
                            },
                            props.removePopupQuestion,
                          );
                        }}
                      />
                      <TooltipBox
                        id="ttdeletepic"
                        content={
                          <div className="opt-table-tooltip grid-5">
                            <div className="cell combined-cells-5 cell-start-content">
                              Borrar foto
                            </div>
                          </div>
                        }
                      ></TooltipBox>
                    </>
                  )}
                {(patientPicture === "/images/avatar.svg" ||
                  patientPicture === "/images/support-extra/hombre.svg" ||
                  patientPicture === "/images/support-extra/mujer.svg") && (
                  <div>
                    {patientId !== -1 && (
                      <input
                        id="file-input"
                        className="hidden"
                        type="file"
                        accept="image/*"
                        value={""}
                        onChange={async (e) => {
                          await uploadNewPatientPic(e.target.value);
                        }}
                      ></input>
                    )}

                    <label htmlFor="file-input">
                      <img
                        id="file-input"
                        src="/images/new-blue.svg"
                        loading="lazy"
                        alt="Icon"
                        data-tooltip-id="ttnewpatientpic"
                        className="small-icon new-pic-icon"
                        onClick={() => {
                          if (patientId === -1) {
                            props.createPopupQuestion(
                              "Por favor, guarde la ficha que está creando antes de añadir la foto del paciente.",
                              () => {
                                props.removePopupQuestion();
                                return;
                              },
                              null,
                              "Entendido",
                            );
                          }
                        }}
                      />
                      <TooltipBox
                        id="ttnewpatientpic"
                        content={
                          <div className="opt-table-tooltip grid-5">
                            <div className="cell combined-cells-5 cell-start-content">
                              Nueva foto
                            </div>
                          </div>
                        }
                      ></TooltipBox>
                    </label>
                    <img
                      src="/images/webcam.svg"
                      loading="lazy"
                      data-tooltip-id="tttakepatientpic"
                      alt="Icon"
                      className="small-icon webcam-icon"
                      onClick={() => {
                        if (patientId === -1) {
                          props.createPopupQuestion(
                            "Por favor, guarde la ficha que está creando antes de añadir la foto del paciente.",
                            () => {
                              props.removePopupQuestion();
                              return;
                            },
                            null,
                            "Entendido",
                          );
                        } else {
                          openCamera();
                        }
                      }}
                    />
                    <TooltipBox
                      id="tttakepatientpic"
                      content={
                        <div className="opt-table-tooltip grid-5">
                          <div className="cell combined-cells-5 cell-start-content">
                            Tomar foto
                          </div>
                        </div>
                      }
                    ></TooltipBox>
                  </div>
                )}
              </div>
              <div className="patient-info-2">
                <div className="patient-name-info">
                  <span className="patient-name">{headerName}</span>
                </div>

                <div className="sep-line"></div>
                <div className="patient-stats">
                  <div className="stats-container">
                    <span className="stat-title">Preferencias</span>
                    <div className="patient-prefs">
                      {Object.entries(currentPatientEdit.preferencias).map(
                        ([preferencia, valor], index) => {
                          return (
                            valor && (
                              <img
                                key={index}
                                src={`/images/${preferencia}.svg`}
                                loading="lazy"
                                className="icon-pref"
                                alt="Preference"
                              />
                            )
                          );
                        },
                      )}
                    </div>
                    <ButtonIconH
                      text="Dar cita"
                      disabled={isDisabled()}
                      icon={svgIcons.schedule}
                      onClick={() => {
                        props.onClickMenuOption("agenda", null);
                      }}
                    ></ButtonIconH>
                  </div>
                  <div className="stats-container">
                    <span className="stat-title">Fidelización</span>
                    <div className="icon-list faces-container">
                      <img
                        src={`${
                          currentPatientEdit.fidelizacionCategoria === "0"
                            ? "/images/face1-blue.svg"
                            : "/images/face1-light-blue.svg"
                        }`}
                        loading="lazy"
                        alt="Icon"
                        className="icon-list-icon"
                      ></img>
                      <img
                        src={`${
                          currentPatientEdit.fidelizacionCategoria === "1"
                            ? "/images/face2-blue.svg"
                            : "/images/face2-light-blue.svg"
                        }`}
                        loading="lazy"
                        alt="Icon"
                        className="icon-list-icon"
                      ></img>
                      <img
                        src={`${
                          currentPatientEdit.fidelizacionCategoria === "2"
                            ? "/images/face3-blue.svg"
                            : "/images/face3-light-blue.svg"
                        }`}
                        loading="lazy"
                        alt="Icon"
                        className="icon-list-icon"
                      ></img>
                    </div>
                    <ButtonIconH
                      text="WhatsApp"
                      disabled={isDisabled()}
                      icon={svgIcons.whatsapp}
                      onClick={() => {
                        handlePatientWhatsapp();
                      }}
                    ></ButtonIconH>
                  </div>
                  <div className="stats-container">
                    <span className="stat-title">Descuento especial</span>
                    <div className="icon-list">
                      {currentPatientEdit.descuentoEspecial}%
                    </div>
                    <ButtonIconH
                      text="Email"
                      icon={svgIcons.email}
                      disabled={isDisabled()}
                      onClick={() => {
                        openEmail();
                      }}
                    ></ButtonIconH>
                  </div>
                  <div className="stats-container">
                    <span className="stat-title">Puntos</span>
                    <div className="icon-list">{currentPatientEdit.puntos}</div>
                    <ButtonIconH
                      text="SMS"
                      icon={svgIcons.sms}
                      disabled={isDisabled()}
                      onClick={() => {
                        openSendSMSPopup(true);
                      }}
                    ></ButtonIconH>
                  </div>
                </div>
              </div>
              <PatientNotifications
                notifications={currentPatientEdit.avisos}
                onClickMenuOption={props.onClickMenuOption}
                patientId={currentPatientEdit.idPaciente}
                patientCode={currentPatientEdit.codigo}
              />
            </div>
            <div className="patient-info-row2">
              <div className="patient-info-4">
                <div className="patient-actions">
                  <div data-tooltip-id="history">
                    <ButtonIconV
                      text="Historial"
                      disabled={isDisabled()}
                      icon={
                        patientId !== -1
                          ? "/images/history-blue.svg"
                          : "/images/history-gray.svg"
                      }
                      onClick={() => {}}
                    ></ButtonIconV>
                    <TooltipBox
                      id="history"
                      content={
                        <div className="opt-table-tooltip grid-2">
                          <div className="cell cell-start-content combined-cells-2">
                            Alta:{" "}
                            {history.fechaAlta
                              ? moment(history.fechaAlta).format("DD/MM/YYYY")
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Actualización:{" "}
                            {history.fechaActualizacion
                              ? moment(history.fechaActualizacion).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Última visita:{" "}
                            {history.fechaUltimaVisita
                              ? moment(history.fechaUltimaVisita).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Última compra:{" "}
                            {history.fechaUltimaCompra
                              ? moment(history.fechaUltimaCompra).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Optometría:{" "}
                            {history.fechaUltimaOptometria
                              ? moment(history.fechaUltimaOptometria).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Audiometría:{" "}
                            {history.fechaUltimaAudiometria
                              ? moment(history.fechaUltimaAudiometria).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Gafa de vista:{" "}
                            {history.fechaUltimaGafaVista
                              ? moment(history.fechaUltimaGafaVista).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Gafa de sol:{" "}
                            {history.fechaUltimaGafaSol
                              ? moment(history.fechaUltimaGafaSol).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Lente de contacto:{" "}
                            {history.fechaUltimaLentesContacto
                              ? moment(
                                  history.fechaUltimaLentesContacto,
                                ).format("DD/MM/YYYY")
                              : ""}
                          </div>
                          <div className="cell cell-start-content combined-cells-2">
                            Audífonos:{" "}
                            {history.fechaUltimaAudifonos
                              ? moment(history.fechaUltimaAudifonos).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </div>
                        </div>
                      }
                    ></TooltipBox>
                  </div>
                  <div ref={menuRef} style={{ position: "relative" }}>
                    <ButtonIconV
                      text="Imprimir"
                      disabled={isDisabled()}
                      icon={
                        patientId !== -1
                          ? "/images/print-blue.svg"
                          : "/images/print-gray.svg"
                      }
                      onClick={() => {
                        if (patientId !== -1) setFloatingMenu((prev) => !prev);
                      }}
                    ></ButtonIconV>
                    {floatingMenu && (
                      <ul
                        className="floating-menu"
                        style={{
                          zIndex: 100,
                          marginTop: 20,
                          top: "100%",
                          bottom: "unset",
                        }}
                      >
                        <li
                          onClick={() => {
                            setFloatingMenu(false);
                            setHandleGDPRConsent(true);
                          }}
                        >
                          Consentimiento RGPD
                        </li>
                        <li
                          onClick={() => {
                            setFloatingMenu(false);
                            setHandleLCConsent(true);
                          }}
                        >
                          Consentimiento LC
                        </li>
                        <li
                          onClick={() => {
                            setFloatingMenu(false);
                            setHandleORTHOKConsent(true);
                          }}
                        >
                          Consentimiento ORTO-K
                        </li>
                        <li
                          onClick={() => {
                            setFloatingMenu(false);
                            setHandleAudioConsent(true);
                          }}
                        >
                          Consentimiento AUDIO
                        </li>
                        <li
                          onClick={async () => {
                            await generateWarrantyLetter();
                          }}
                        >
                          Carta de garantía
                        </li>
                        <li
                          onClick={async () => {
                            await generateAttendanceCertificate();
                          }}
                        >
                          Justificante de asistencia
                        </li>
                      </ul>
                    )}
                  </div>
                  <ButtonIconV
                    text="Recargar"
                    icon={
                      patientId !== -1
                        ? "/images/update-blue.svg"
                        : "/images/update-gray.svg"
                    }
                    disabled={isDisabled()}
                    onClick={async () => {
                      if (patientDataChanges) {
                        props.createPopupQuestion(
                          `Existen cambios sin guardar en la ficha del paciente actual${`
                            (${
                              currentPatient.nombre +
                              " " +
                              currentPatient.apellidos
                            })`}. ¿Desea guardar los cambios antes de recargar?`,
                          async () => {
                            if (!patientReadyToSave) {
                              popUpIncompleteData();
                            } else {
                              props.removePopupQuestion();
                              const saved = await savePatientData();
                              if (saved) {
                                await getPatientData(patientId);
                              }
                            }
                          },
                          async () => {
                            props.removePopupQuestion();
                            await getPatientData(patientId);
                          },
                          "Sí",
                          "No",
                          () => {
                            props.removePopupQuestion();
                          },
                          "Cancelar",
                        );
                      } else {
                        props.createPopupQuestion(
                          `¿Desea recargar los datos del paciente?`,
                          async () => {
                            props.removePopupQuestion();
                            await getPatientData(patientId);
                          },
                          props.removePopupQuestion,
                        );
                      }
                    }}
                  ></ButtonIconV>
                  <ButtonIconV
                    text="Guardar"
                    icon="/images/save-blue.svg"
                    onClick={async () => {
                      if (!patientReadyToSave) {
                        popUpIncompleteData();
                      } else {
                        await checkDuplicateAndProceed(async () => {
                          await createBeforeSaving();
                          const saved = await savePatientData();
                          if (!saved) {
                            return;
                          }
                          props.createPopupQuestion(
                            `Los cambios se han guardado con éxito.`,
                            props.removePopupQuestion,
                            null,
                            "Entendido",
                          );
                          props.onClickMenuOption("patient-datos", {
                            patientId,
                          });
                        });
                      }
                    }}
                  ></ButtonIconV>

                  {patientId === -1 && (
                    <ButtonIconV
                      text="Cancelar"
                      icon="/images/cancel-blue.svg"
                      onClick={() => {
                        props.createPopupQuestion(
                          `¿Desea cancelar la creación de la ficha de paciente?`,
                          async () => {
                            cancellingCreationRef.current = true;
                            setCurrentPatientEdit(currentPatient);
                            setPatientAge("");
                            props.onGoBack();
                            props.removePopupQuestion();
                          },
                          props.removePopupQuestion,
                        );
                      }}
                    ></ButtonIconV>
                  )}
                  {patientId !== -1 && (
                    <ButtonIconV
                      text="Eliminar"
                      icon="/images/remove-blue.svg"
                      onClick={() => {
                        props.createPopupQuestion(
                          `¿Desea eliminar la ficha del paciente?`,
                          async () => {
                            await deletePatient();
                            props.removePopupQuestion();
                            setForceReload(false);
                            props.onClickMenuOption("patient-search", null);
                          },
                          props.removePopupQuestion,
                        );
                      }}
                    ></ButtonIconV>
                  )}
                  <ButtonIconV
                    text={`Cesta (${numSC})`}
                    disabled={isDisabled()}
                    icon={
                      patientId !== -1
                        ? numSC > 0
                          ? "/images/shopping-cart-full.svg"
                          : "/images/shopping-cart-blue.svg"
                        : "/images/shopping-cart-gray.svg"
                    }
                    onClick={() => {
                      props.openShoppingCartPanel();
                    }}
                  ></ButtonIconV>
                </div>
                <div className="patient-action-buttons">
                  <ButtonIconH
                    text="Fidelización"
                    disabled={isDisabled()}
                    onClick={() => openLoyaltyPopup(true)}
                  ></ButtonIconH>
                  <ButtonIconH
                    text={"Vales de caja (" + numCashVouchers + ")"}
                    disabled={isDisabled()}
                    onClick={() => openCashVoucherPopup(true)}
                  ></ButtonIconH>
                  <ButtonIconH
                    text={`Sanidad (${healthData.length})`}
                    disabled={isDisabled()}
                    onClick={() => {
                      if (!isDisabled()) {
                        const healthDataLines = healthData.map((item) => ({
                          id: item.idDatoSanitario,
                          line: {
                            code: item.codigoArticulo,
                            healthControl: {
                              date: item.fechaCompra,
                              description: item.descripcion,
                              deliveryNote: item.nAlbaran,
                              shippingNumber: item.nExpedicion,
                              lotNumber: item.nLote,
                            },
                          },
                        }));

                        props.openHealthDataPanel({
                          name: "Datos sanitarios",
                          onRequestClose: () =>
                            healthDataRef.current?.requestClose(),
                          component: (
                            <HealthData
                              ref={healthDataRef}
                              lines={healthDataLines}
                              mode="patient"
                              createPopupQuestion={props.createPopupQuestion}
                              removePopupQuestion={props.removePopupQuestion}
                              onAccept={async (updatedList) => {
                                const response = await post(
                                  "ActualizarDatosSanitarios.php",
                                  {
                                    token: userData.token,
                                    optica: selectedOptic.id,
                                    idPaciente: patientId,
                                    idAgente: userData.id,
                                    datosSanitarios: updatedList.map(
                                      (item) => ({
                                        id: item.idDatoSanitario,
                                        fechaCompra: item.fechaCompra,
                                        codigoArticulo: item.codigoArticulo,
                                        nAlbaran: item.nAlbaran,
                                        nExpedicion: item.nExpedicion,
                                        nLote: item.nLote,
                                        descripcion: item.descripcion,
                                      }),
                                    ),
                                  },
                                );
                                if (response && response.error) {
                                  props.createPopupQuestion(
                                    response.error,
                                    () => props.removePopupQuestion(),
                                    null,
                                    "Cerrar",
                                  );
                                  return false;
                                }
                                await getHealthData(patientId);
                                return true;
                              }}
                              onClose={() => props.closeHealthDataPanel()}
                            ></HealthData>
                          ),
                        });
                      }
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text={`Gestión documental (${formatValueUnit(numFilesDM)})`}
                    disabled={isDisabled()}
                    onClick={() => {
                      setHandleDocumentManagement(true);
                    }}
                  ></ButtonIconH>
                </div>
              </div>
            </div>
            <div className="patient-info-row2">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  borderLeft: "1px solid #d6d6d6",
                  paddingLeft: "15px",
                }}
              >
                <ButtonIconV
                  text="Buscar paciente"
                  icon="/images/search-orange.svg"
                  onClick={async () => {
                    if (patientDataChanges) {
                      props.createPopupQuestion(
                        `Existen cambios sin guardar en la ficha del paciente actual${
                          currentPatient.idPaciente !== -1
                            ? ` (${
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos
                              })`
                            : ``
                        }. ¿Desea guardar los cambios antes de ir a la búsqueda de pacientes?`,
                        async () => {
                          if (!patientReadyToSave) {
                            popUpIncompleteData();
                          } else {
                            await createBeforeSaving();
                            const saved = await savePatientData();
                            if (!saved) {
                              return;
                            }
                            props.createPopupQuestion(
                              `Los cambios se han guardado con éxito.`,
                              props.removePopupQuestion,
                              null,
                              "Entendido",
                            );
                            setForceReload(false);
                            props.onClickMenuOption("patient-search", null);
                            props.removePopupQuestion();
                          }
                        },
                        async () => {
                          setForceReload(false);
                          props.onClickMenuOption("patient-search", null);
                          props.removePopupQuestion();
                        },
                        "Sí",
                        "No",
                        () => {
                          props.removePopupQuestion();
                        },
                        "Cancelar",
                      );
                    } else {
                      setForceReload(false);
                      props.onClickMenuOption("patient-search", null);
                    }
                  }}
                ></ButtonIconV>

                <ButtonIconV
                  text="Nuevo paciente"
                  icon="/images/add-orange.svg"
                  onClick={() => {
                    if (currentPatientEdit.idPaciente !== -1) {
                      props.createPopupQuestion(
                        patientDataChanges
                          ? `Existen cambios sin guardar en la ficha del paciente actual${
                              currentPatient.idPaciente !== -1
                                ? ` (${
                                    currentPatient.nombre +
                                    " " +
                                    currentPatient.apellidos
                                  })`
                                : ``
                            }. ¿Desea guardar los cambios antes de crear una nueva ficha de paciente?`
                          : `Se va a proceder a la creación de una nueva ficha de paciente.`,
                        async () => {
                          if (!patientReadyToSave) {
                            popUpIncompleteData();
                          } else {
                            if (patientDataChanges) {
                              const saved = await savePatientData();
                              if (!saved) {
                                return;
                              }
                            }
                            props.removePopupQuestion();
                            await createPatient();
                            props.onClickMenuOption("patient-datos", {
                              patientId: -1,
                            });
                          }
                        },
                        async () => {
                          if (patientDataChanges) {
                            await createPatient();
                            props.onClickMenuOption("patient-datos", {
                              patientId: -1,
                            });
                          }
                          props.removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    } else {
                      props.createPopupQuestion(
                        `Ya está creando una nueva ficha de paciente.`,
                        props.removePopupQuestion,
                        null,
                        "Entendido",
                      );
                    }
                  }}
                ></ButtonIconV>
              </div>
            </div>
          </div>
          <div className={`patient-sections ${loadingPatient ? "hidden" : ""}`}>
            <div className="patient-section" id="Datos">
              <div className="section-header">
                <img
                  src="/images/patient-data-section.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Datos</span>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setToggleDataSection(!toggleDataSection);
                  }}
                >
                  <img
                    src={
                      toggleDataSection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {toggleDataSection && (
                <div className="section-content">
                  <div className="section-content-info sec-1">
                    <span className="section-content-title">
                      Datos personales
                    </span>
                    <div className="section-content-sep"></div>
                    <div className="section-content-data">
                      <div className="data-field-row">
                        <div
                          className="data-field-extra"
                          style={{ width: "auto" }}
                        >
                          <div className="data-field d-small-extra d-small-extra-2">
                            <span className="label">Código</span>
                            <InputIconSearch
                              tabIndex={0}
                              inactive={patientId === -1}
                              type="type-alphanum-ext"
                              size={7}
                              maxLength={10}
                              input={patientCode}
                              onChange={(e) => {
                                setPatientCode(e);
                              }}
                              onClear={() => {
                                focusElement(0);
                                setPatientCode("");
                              }}
                              onEnter={async () => {
                                await getPatientId();
                              }}
                            ></InputIconSearch>
                          </div>
                          <div className="data-field" data-tooltip-id="niftype">
                            <span className="label">NIF </span>
                            <InputData
                              tabIndex={1}
                              type="type-only-charnumbers"
                              size={8}
                              maxLength={12}
                              input={currentPatientEdit.nif}
                              nifType={currentPatientEdit.tipoNif}
                              onChange={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  nif: e,
                                });
                              }}
                              icon="/images/link.svg"
                              onClick={() => {
                                setIdentityNumberTypes(true);
                              }}
                            ></InputData>
                            <span style={{ fontWeight: 500 }}>
                              {selectedDocumentType.documentId}
                            </span>
                          </div>
                          <TooltipBox
                            id="niftype"
                            content={
                              <div className="opt-table-tooltip grid-5">
                                <div className="cell combined-cells-5 cell-start-content">
                                  Seleccionar tipo de documento
                                </div>
                              </div>
                            }
                          ></TooltipBox>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Sexo</span>
                          <Dropdown
                            id="sexo"
                            tabIndex={11}
                            optionList={sexOptions}
                            size={1}
                            op={currentPatientEdit.sexo}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                sexo: e.id,
                              });
                            }}
                          ></Dropdown>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Fidelización</span>
                          <InputData
                            id="fidelizacion"
                            tabIndex={2}
                            size={3}
                            inactive={true}
                            input={currentPatientEdit.fidelizacion}
                            onChange={() => {}}
                          ></InputData>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Edad</span>
                          <InputData
                            id="edad"
                            type="type-integer"
                            size={1}
                            inactive={true}
                            input={patientAge}
                            onChange={() => {}}
                          ></InputData>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Nombre (*)</span>
                          <InputData
                            tabIndex={3}
                            id="nombre"
                            type="type-alpha"
                            size={3}
                            input={currentPatientEdit.nombre}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                nombre: e,
                              });
                            }}
                          ></InputData>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Nacimiento</span>
                          <input
                            type="date"
                            max={new Date().toISOString().slice(0, 10)}
                            tabIndex={13}
                            className="input-field"
                            value={currentPatientEdit.nacimiento}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                nacimiento: e.target.value,
                              });
                            }}
                            onBlur={validateDate}
                            onKeyUp={(e) => inputOnEnter(e)}
                          ></input>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Apellidos (*)</span>
                          <InputData
                            tabIndex={4}
                            id="apellidos"
                            type="type-alpha"
                            size={3}
                            input={currentPatientEdit.apellidos}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                apellidos: e,
                              });
                            }}
                          ></InputData>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Código postal</span>
                          <InputData
                            id="codigopostal"
                            tabIndex={14}
                            type="type-cp"
                            size={1}
                            maxLength={5}
                            input={currentPatientEdit.codigoPostal}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                codigoPostal: e,
                              });
                            }}
                            onMalformed={() => setErrorCP(true)}
                            error={errorCP}
                            icon="/images/link.svg"
                            onClick={() => {}}
                          ></InputData>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Dirección</span>
                          <InputData
                            tabIndex={5}
                            id="direccion"
                            type="type-alphanum-ext"
                            size={3}
                            input={currentPatientEdit.direccion}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                direccion: e,
                              });
                            }}
                          ></InputData>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Teléfono</span>
                          <InputData
                            id="telefono"
                            tabIndex={15}
                            type="type-phone"
                            maxLength={20}
                            size={1}
                            input={currentPatientEdit.telefono}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                telefono: e,
                              });
                            }}
                          ></InputData>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Localidad</span>
                          <InputData
                            tabIndex={6}
                            id="localidad"
                            type="type-alpha"
                            size={3}
                            input={currentPatientEdit.localidad}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                localidad: e,
                              });
                            }}
                          ></InputData>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Móvil</span>
                          <InputData
                            tabIndex={16}
                            type="type-phone"
                            size={1}
                            maxLength={20}
                            input={currentPatientEdit.movil}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                movil: e,
                              });
                            }}
                          ></InputData>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Provincia</span>
                          <Dropdown
                            tabIndex={7}
                            disabled={false}
                            optionList={provinceOptions}
                            size={3}
                            op={currentPatientEdit.provincia}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                provincia: e.id,
                              });
                            }}
                          ></Dropdown>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Carné de conducir</span>
                          <div className="radio-ops-container">
                            <div
                              className="data-field c-pointer"
                              onClick={() => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  carnetConducir: true,
                                });
                              }}
                            >
                              <RadioButton
                                tabIndex={18}
                                active={currentPatientEdit.carnetConducir}
                                onClick={() => {}}
                              ></RadioButton>
                              <span className="label">Sí</span>
                            </div>
                            <div
                              className="data-field c-pointer"
                              onClick={() => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  carnetConducir: false,
                                });
                              }}
                            >
                              <RadioButton
                                tabIndex={19}
                                active={!currentPatientEdit.carnetConducir}
                                onClick={() => {}}
                              ></RadioButton>
                              <span className="label">No</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Email</span>
                          <InputData
                            id="email"
                            tabIndex={8}
                            type="type-email"
                            size={3}
                            input={currentPatientEdit.email}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                email: e,
                              });
                            }}
                            onMalformed={() => setErrorEmail(true)}
                            error={errorEmail}
                          ></InputData>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Tiene hijos</span>
                          <div className="radio-ops-container">
                            <div
                              className="data-field c-pointer"
                              onClick={() => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  tieneHijos: !currentPatientEdit.tieneHijos,
                                });
                              }}
                            >
                              <RadioButton
                                tabIndex={20}
                                active={currentPatientEdit.tieneHijos}
                                onClick={() => {}}
                              ></RadioButton>
                              <span className="label">Sí</span>
                            </div>
                            <div
                              className="data-field c-pointer"
                              onClick={() => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  tieneHijos: !currentPatientEdit.tieneHijos,
                                });
                              }}
                            >
                              <RadioButton
                                tabIndex={21}
                                active={!currentPatientEdit.tieneHijos}
                                onClick={() => {}}
                              ></RadioButton>
                              <span className="label">No</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Campaña</span>
                          <Dropdown
                            id="campana"
                            tabIndex={9}
                            disabled={false}
                            optionList={campaignList}
                            size={3}
                            op={currentPatientEdit.campana}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                campana: e.id,
                              });
                            }}
                            mandatory={false}
                          ></Dropdown>
                        </div>
                        <div className="data-field d-small">
                          <span className="label">Código rec.</span>
                          <InputSearch
                            id="codigorec"
                            size={1}
                            tabIndex={22}
                            link={true}
                            code={true}
                            op={currentPatientEdit.codigoRec}
                            onSelect={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                codigoRec: e.codigo,
                                idPacienteCodigoRec: e.idPaciente,
                              });
                            }}
                            onClickLink={() => {
                              if (
                                currentPatientEdit.idPacienteCodigoRec !== ""
                              ) {
                                window.open(
                                  `/patient-datos/${currentPatientEdit.idPacienteCodigoRec}`,
                                );
                              }
                            }}
                            showCode={true}
                          ></InputSearch>
                        </div>
                      </div>
                      <div className="data-field-row">
                        <div className="data-field d-large">
                          <span className="label">Recomendado</span>
                          <Dropdown
                            id="recomendado"
                            tabIndex={10}
                            disabled={false}
                            optionList={recommendedList}
                            size={3}
                            op={currentPatientEdit.recomendado}
                            onChange={(e) => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                recomendado: e.id,
                              });
                            }}
                            mandatory={false}
                          ></Dropdown>
                        </div>
                        <div className="data-field d-small"></div>
                      </div>
                    </div>
                  </div>
                  <div className="section-content-info sec-2">
                    <span className="section-content-title">
                      Consentimientos
                    </span>
                    <div className="section-content-sep"></div>
                    <div className="section-content-data">
                      <div className="grid-content">
                        <div
                          className="data-field c-pointer"
                          onClick={() => {
                            setCurrentPatientEdit({
                              ...currentPatientEdit,
                              consentimientosRGPD:
                                !currentPatientEdit.consentimientosRGPD,
                            });
                          }}
                        >
                          <span className="label">RGPD</span>
                          <CheckBox
                            tabIndex={29}
                            active={currentPatientEdit.consentimientosRGPD}
                            onClick={() => {}}
                          ></CheckBox>
                        </div>
                        <div
                          className="data-field c-pointer"
                          onClick={() => {
                            setCurrentPatientEdit({
                              ...currentPatientEdit,
                              consentimientosAudiologia:
                                !currentPatientEdit.consentimientosAudiologia,
                            });
                          }}
                        >
                          <span className="label">Audiología</span>
                          <CheckBox
                            tabIndex={30}
                            active={
                              currentPatientEdit.consentimientosAudiologia
                            }
                            onClick={() => {}}
                          ></CheckBox>
                        </div>
                        <div
                          className="data-field c-pointer"
                          onClick={() => {
                            setCurrentPatientEdit({
                              ...currentPatientEdit,
                              consentimientosLC:
                                !currentPatientEdit.consentimientosLC,
                            });
                          }}
                        >
                          <span className="label">LC</span>
                          <CheckBox
                            tabIndex={31}
                            active={currentPatientEdit.consentimientosLC}
                            onClick={() => {}}
                          ></CheckBox>
                        </div>
                        <div
                          className="data-field c-pointer"
                          onClick={() => {
                            setCurrentPatientEdit({
                              ...currentPatientEdit,
                              consentimientosORTOK:
                                !currentPatientEdit.consentimientosORTOK,
                            });
                          }}
                        >
                          <span className="label">ORTO-K</span>
                          <CheckBox
                            tabIndex={32}
                            active={currentPatientEdit.consentimientosORTOK}
                            onClick={() => {}}
                          ></CheckBox>
                        </div>
                      </div>
                      <div>
                        <div
                          className="data-field c-pointer"
                          onClick={() => {
                            setCheckboxState({
                              ...checkboxState,
                              checkboxServices: !checkboxState.checkboxServices,
                            });
                            setCurrentPatientEdit({
                              ...currentPatientEdit,
                              serviciosEmail: !checkboxState.checkboxServices,
                              serviciosPostal: !checkboxState.checkboxServices,
                              serviciosSMS: !checkboxState.checkboxServices,
                              serviciosTelefono:
                                !checkboxState.checkboxServices,
                              serviciosWhatsapp:
                                !checkboxState.checkboxServices,
                            });
                          }}
                        >
                          <span
                            className="label"
                            style={{ color: "#4a4a4a", fontWeight: 600 }}
                          >
                            Servicios
                          </span>
                          <CheckBox
                            tabIndex={33}
                            active={checkboxState.checkboxServices}
                            onClick={() => {}}
                          ></CheckBox>
                        </div>
                        <div className="section-content-sep-2"></div>
                        <div className="grid-content">
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                serviciosWhatsapp:
                                  !currentPatientEdit.serviciosWhatsapp,
                              });
                            }}
                          >
                            <span className="label">Whatsapp</span>
                            <CheckBox
                              tabIndex={34}
                              active={currentPatientEdit.serviciosWhatsapp}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                serviciosEmail:
                                  !currentPatientEdit.serviciosEmail,
                              });
                            }}
                          >
                            <span className="label">Email</span>
                            <CheckBox
                              tabIndex={35}
                              active={currentPatientEdit.serviciosEmail}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                serviciosSMS: !currentPatientEdit.serviciosSMS,
                              });
                            }}
                          >
                            <span className="label">SMS</span>
                            <CheckBox
                              tabIndex={36}
                              active={currentPatientEdit.serviciosSMS}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                serviciosTelefono:
                                  !currentPatientEdit.serviciosTelefono,
                              });
                            }}
                          >
                            <span className="label">Teléfono</span>
                            <CheckBox
                              tabIndex={37}
                              active={currentPatientEdit.serviciosTelefono}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                serviciosPostal:
                                  !currentPatientEdit.serviciosPostal,
                              });
                            }}
                          >
                            <span className="label">Postal</span>
                            <CheckBox
                              tabIndex={38}
                              active={currentPatientEdit.serviciosPostal}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div
                          className="data-field c-pointer"
                          onClick={() => {
                            setCheckboxState({
                              ...checkboxState,
                              checkboxCommercial:
                                !checkboxState.checkboxCommercial,
                            });
                            setCurrentPatientEdit({
                              ...currentPatientEdit,
                              comercialEmail: !checkboxState.checkboxCommercial,
                              comercialPostal:
                                !checkboxState.checkboxCommercial,
                              comercialSMS: !checkboxState.checkboxCommercial,
                              comercialTelefono:
                                !checkboxState.checkboxCommercial,
                              comercialWhatsapp:
                                !checkboxState.checkboxCommercial,
                            });
                          }}
                        >
                          <span
                            className="label"
                            style={{ color: "#4a4a4a", fontWeight: 600 }}
                          >
                            Comercial
                          </span>
                          <CheckBox
                            tabIndex={39}
                            active={checkboxState.checkboxCommercial}
                            onClick={() => {}}
                          ></CheckBox>
                        </div>
                        <div className="section-content-sep-2"></div>
                        <div className="grid-content">
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                comercialWhatsapp:
                                  !currentPatientEdit.comercialWhatsapp,
                              });
                            }}
                          >
                            <span className="label">Whatsapp</span>
                            <CheckBox
                              tabIndex={40}
                              active={currentPatientEdit.comercialWhatsapp}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                comercialEmail:
                                  !currentPatientEdit.comercialEmail,
                              });
                            }}
                          >
                            <span className="label">Email</span>
                            <CheckBox
                              tabIndex={41}
                              active={currentPatientEdit.comercialEmail}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                comercialSMS: !currentPatientEdit.comercialSMS,
                              });
                            }}
                          >
                            <span className="label">SMS</span>
                            <CheckBox
                              tabIndex={42}
                              active={currentPatientEdit.comercialSMS}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                comercialTelefono:
                                  !currentPatientEdit.comercialTelefono,
                              });
                            }}
                          >
                            <span className="label">Teléfono</span>
                            <CheckBox
                              tabIndex={43}
                              active={currentPatientEdit.comercialTelefono}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setCurrentPatientEdit({
                                ...currentPatientEdit,
                                comercialPostal:
                                  !currentPatientEdit.comercialPostal,
                              });
                            }}
                          >
                            <span className="label">Postal</span>
                            <CheckBox
                              tabIndex={44}
                              active={currentPatientEdit.comercialPostal}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="combined-section">
                    <div className="section-content-info sec-5 combined-section-child">
                      <span className="section-content-title">
                        Aficiones ({currentPatientEdit.aficiones.length})
                      </span>
                      <div className="section-content-sep"></div>
                      <div className="section-content-data">
                        {currentPatientEdit.aficiones &&
                          currentPatientEdit.aficiones.length > 0 && (
                            <div className="tag-content">
                              {currentPatientEdit.aficiones.map((e, i) => {
                                return (
                                  <Tag
                                    text={e}
                                    key={i}
                                    tagId={i}
                                    onClick={(e) => {
                                      setCurrentPatientEdit({
                                        ...currentPatientEdit,
                                        aficiones:
                                          currentPatientEdit.aficiones.filter(
                                            (i) => i !== e,
                                          ),
                                      });
                                    }}
                                  ></Tag>
                                );
                              })}
                            </div>
                          )}
                        {currentPatientEdit.aficiones &&
                          currentPatientEdit.aficiones.length === 0 && (
                            <span className="section-content-message">
                              Todavía no hay datos registrados.
                            </span>
                          )}
                        <div className="section-content-buttons">
                          <div className="add-hobby-container">
                            <Dropdown
                              disabled={false}
                              optionList={hobbiesList}
                              size={0}
                              op={selectedHobby}
                              onChange={(e) => {
                                setSelectedHobby(e.id);
                              }}
                              mandatory={true}
                            ></Dropdown>
                            <div
                              className="mini-button fill-blue"
                              onClick={() => {
                                if (
                                  !currentPatientEdit.aficiones.includes(
                                    selectedHobby,
                                  ) &&
                                  selectedHobby !== ""
                                ) {
                                  setCurrentPatientEdit({
                                    ...currentPatientEdit,
                                    aficiones: [
                                      ...currentPatientEdit.aficiones,
                                      selectedHobby,
                                    ],
                                  });
                                  setSelectedHobby("");
                                }
                              }}
                            >
                              <img
                                src="/images/accept.svg"
                                loading="lazy"
                                alt="Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="section-content-info sec-5 combined-section-child">
                      <span className="section-content-title">
                        Ametropías ({currentPatientEdit.ametropias.length})
                      </span>
                      <div className="section-content-sep"></div>
                      <div className="section-content-data">
                        {currentPatientEdit.ametropias &&
                          currentPatientEdit.ametropias.length > 0 && (
                            <div className="tag-content">
                              {currentPatientEdit.ametropias.map((e, i) => {
                                return (
                                  <Tag
                                    text={e}
                                    key={i}
                                    tagId={i}
                                    onClick={() => {
                                      setCurrentPatientEdit({
                                        ...currentPatientEdit,
                                        ametropias:
                                          currentPatientEdit.ametropias.filter(
                                            (i) => i !== e,
                                          ),
                                      });
                                    }}
                                  ></Tag>
                                );
                              })}
                            </div>
                          )}
                        {currentPatientEdit.ametropias &&
                          currentPatientEdit.ametropias.length === 0 && (
                            <span className="section-content-message">
                              Todavía no hay datos registrados.
                            </span>
                          )}
                        <div className="section-content-buttons">
                          <div className="add-hobby-container">
                            <Dropdown
                              disabled={false}
                              optionList={[
                                { id: "", text: "" },
                                ...ametropiaList,
                              ]}
                              size={0}
                              op={selectedAmetropia}
                              onChange={(e) => {
                                setSelectedAmetropia(e.id);
                              }}
                              mandatory={true}
                            ></Dropdown>
                            <div
                              className="mini-button fill-blue"
                              onClick={() => {
                                if (
                                  !currentPatientEdit.ametropias.includes(
                                    selectedAmetropia,
                                  ) &&
                                  selectedAmetropia !== ""
                                ) {
                                  setCurrentPatientEdit({
                                    ...currentPatientEdit,
                                    ametropias: [
                                      ...currentPatientEdit.ametropias,
                                      selectedAmetropia,
                                    ],
                                  });
                                  setSelectedAmetropia("");
                                }
                              }}
                            >
                              <img
                                src="/images/accept.svg"
                                loading="lazy"
                                alt="Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="contacto-trabajo">
                    <div className="section-content-info sec-3">
                      <span className="section-content-title">
                        Persona de contacto
                      </span>
                      <div className="section-content-sep"></div>
                      <div className="section-content-data">
                        <div className="data-field-row">
                          <div className="data-field d-medium">
                            <span className="label">Nombre</span>
                            <InputSearch
                              id="contactonombre"
                              tabIndex={23}
                              type="type-alpha"
                              size={2}
                              op={currentPatientEdit.personaContactoNombre}
                              onSelect={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  personaContactoCodigo: e.codigo,
                                  personaContactoNombre:
                                    e.nombre + " " + e.apellidos,
                                  personaContactoTelefono: e.telefono,
                                });
                              }}
                              showCode={false}
                            ></InputSearch>
                          </div>
                        </div>
                        <div className="data-field-row">
                          <div className="data-field d-medium">
                            <span className="label">Código</span>
                            <InputData
                              id="contactocodigo"
                              tabIndex={24}
                              size={2}
                              input={currentPatientEdit.personaContactoCodigo}
                              onChange={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  personaContactoCodigo: e,
                                });
                              }}
                            ></InputData>
                          </div>
                        </div>
                        <div className="data-field-row">
                          <div className="data-field d-medium">
                            <span className="label">Teléfono</span>
                            <InputData
                              id="contactotelefono"
                              type="type-phone"
                              tabIndex={25}
                              size={2}
                              input={currentPatientEdit.personaContactoTelefono}
                              onChange={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  personaContactoTelefono: e,
                                });
                              }}
                            ></InputData>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="section-content-info sec-3">
                      <span className="section-content-title">Trabajo</span>
                      <div className="section-content-sep"></div>
                      <div className="section-content-data">
                        <div className="data-field-row">
                          <div className="data-field d-medium">
                            <span className="label">Profesión</span>
                            <InputData
                              id="trabajoprofesion"
                              tabIndex={26}
                              type="type-alpha"
                              size={2}
                              input={currentPatientEdit.trabajoProfesion}
                              onChange={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  trabajoProfesion: e,
                                });
                              }}
                            ></InputData>
                          </div>
                        </div>
                        <div className="data-field-row">
                          <div className="data-field d-medium">
                            <span className="label">Empresa</span>
                            <InputData
                              id="trabajoempresa"
                              type="type-alphanum"
                              tabIndex={27}
                              size={2}
                              input={currentPatientEdit.trabajoEmpresa}
                              onChange={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  trabajoEmpresa: e,
                                });
                              }}
                            ></InputData>
                          </div>
                        </div>
                        <div className="data-field-row">
                          <div className="data-field d-medium">
                            <span className="label">Teléfono</span>
                            <InputData
                              id="trabajotelefono"
                              tabIndex={28}
                              type="type-phone"
                              size={2}
                              input={currentPatientEdit.trabajoTelefono}
                              onChange={(e) => {
                                setCurrentPatientEdit({
                                  ...currentPatientEdit,
                                  trabajoTelefono: e,
                                });
                              }}
                            ></InputData>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="section-content-info sec-4">
                    <span className="section-content-title">Observaciones</span>
                    <div className="section-content-sep"></div>
                    <div className="section-content-data">
                      <span className="section-content-message">
                        Hay&nbsp;
                        <span className="obs-text">
                          {numObservations}&nbsp;observaciones&nbsp;
                        </span>
                        para este paciente.
                      </span>
                      <div className="section-content-buttons">
                        <ButtonIconH
                          text="Abrir"
                          small={true}
                          onClick={() => {
                            if (patientId !== -1) {
                              props.openObservationsPanel(
                                {
                                  id: patientId,
                                  name:
                                    currentPatient.nombre +
                                    " " +
                                    currentPatient.apellidos,
                                },
                                patientId,
                                async () => {
                                  await getObservations(props.patientId);
                                },
                                "Paciente",
                              );
                            } else {
                              props.createPopupQuestion(
                                "Por favor, guarde la ficha que está creando antes de abrir el panel de observaciones.",
                                props.removePopupQuestion,
                                null,
                                "Entendido",
                              );
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="patient-section" id="Compras">
              <div className="section-header">
                <img
                  src="/images/menu-shopping-bag.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Ventas</span>
                <div className="patient-section-actions">
                  <ButtonSectionHeader
                    icon="/images/new-white.svg"
                    text="Nuevo"
                    onClick={onClickNewSale}
                  ></ButtonSectionHeader>
                  <div className="patient-section-actions-extra">
                    <ButtonSectionHeader
                      icon="/images/update-white.svg"
                      text="Actualizar"
                    ></ButtonSectionHeader>
                    <PrintExportMenu
                      onSelect={exportComprasReport}
                      hasData={salesExportData?.sales?.length > 0}
                      onNoData={showNoPrintDataPopup}
                    ></PrintExportMenu>
                    {/* <ButtonSectionHeader
                      icon="/images/export-white.svg"
                      text="Exportar"
                    ></ButtonSectionHeader> */}
                  </div>
                </div>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setTogglePurchasingSection(!togglePurchasingSection);
                  }}
                >
                  <img
                    src={
                      togglePurchasingSection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {togglePurchasingSection && (
                <div className="section-content">
                  <span className="section-todo">
                    <PatientSaleHistory
                      patientId={patientId}
                      onClickMenuOption={props.onClickMenuOption}
                      onDataChange={setSalesExportData}
                    />
                  </span>
                </div>
              )}
            </div>
            <div className="patient-section" id="Optometría">
              <div className="section-header">
                <img
                  src="/images/menu-multiestenope.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Optometría</span>
                <div className="patient-section-actions">
                  <ButtonSectionHeader
                    icon="/images/new-white.svg"
                    text="Nuevo"
                    onClick={() => {
                      if (currentPatientEdit.idPaciente !== -1) {
                        openOptoPanelForNewOpto();
                      }
                    }}
                  ></ButtonSectionHeader>
                  <div className="patient-section-actions-extra">
                    <ButtonSectionHeader
                      icon="/images/update-white.svg"
                      text="Actualizar"
                      onClick={async () => {
                        if (currentPatientEdit.idPaciente !== -1) {
                          await getOptometryHistory(patientId);
                        }
                      }}
                    ></ButtonSectionHeader>
                    <PrintExportMenu
                      onSelect={exportOptometriasReport}
                      hasData={optometryHistoryList?.length > 0}
                      onNoData={showNoPrintDataPopup}
                    ></PrintExportMenu>
                    {/* <ButtonSectionHeader
                      icon="/images/export-white.svg"
                      text="Exportar"
                    ></ButtonSectionHeader> */}
                  </div>
                </div>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setToggleOptometrySection(!toggleOptometrySection);
                  }}
                >
                  <img
                    src={
                      toggleOptometrySection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {toggleOptometrySection && (
                <div className="section-content">
                  <div className="section-todo">
                    <div className="optometry-icon-header">
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.optometria.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            0,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.optometria.num > 0
                              ? "/images/optometry-orange.svg"
                              : "/images/optometry-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>
                          Optometría ({numOptometries.optometria.num})
                        </span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.anamnesis.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            1,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.anamnesis.num > 0
                              ? "images/anamnesis-orange.svg"
                              : "/images/anamnesis-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>Anamnesis ({numOptometries.anamnesis.num})</span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.refractivo.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            2,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.refractivo.num > 0
                              ? "/images/rx-orange.svg"
                              : "/images/rx-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>
                          Refractivo ({numOptometries.refractivo.num})
                        </span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.oculomotor.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            3,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.oculomotor.num > 0
                              ? "/images/accommodative-orange.svg"
                              : "/images/accommodative-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>
                          Oculomotor ({numOptometries.oculomotor.num})
                        </span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.binocular.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            4,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.binocular.num > 0
                              ? "/images/binocular-orange.svg"
                              : "/images/binocular-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>Binocular ({numOptometries.binocular.num})</span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.acomodativo.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            5,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.acomodativo.num > 0
                              ? "/images/accommodative-orange.svg"
                              : "/images/accommodative-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>
                          Acomodativo ({numOptometries.acomodativo.num})
                        </span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.sensorial.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            6,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.sensorial.num > 0
                              ? "/images/sensory-orange.svg"
                              : "/images/sensory-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>Sensorial ({numOptometries.sensorial.num})</span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.saludOcular.num > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            7,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.saludOcular.num > 0
                              ? "/images/eye-health-orange.svg"
                              : "/images/eye-health-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>
                          Salud ocular ({numOptometries.saludOcular.num})
                        </span>
                      </button>
                      <button
                        className={`optometry-icon-header-icon ${
                          numOptometries.ficheros > 0 ? "bkg-orange" : ""
                        }`}
                        disabled={patientId === -1}
                        onClick={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            8,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      >
                        <img
                          src={
                            numOptometries.ficheros > 0
                              ? "/images/files-orange.svg"
                              : "/images/files-blue.svg"
                          }
                          loading="lazy"
                          alt="Icon"
                        ></img>
                        <span>
                          Ficheros ({formatValueUnit(numOptometries.ficheros)})
                        </span>
                      </button>
                    </div>
                    {optometryHistoryList.length > 0 && (
                      <span className="section-history-header">
                        {!optometrySectionSeeMore
                          ? "Última optometría"
                          : `Histórico (${optometryHistoryList.length})`}
                      </span>
                    )}
                    {optometryHistoryList.length > 0 && (
                      <div className="section-content-sep"></div>
                    )}
                    {optometryHistoryList.length > 0 && (
                      <OptometryHistoryBox
                        opt={optometryHistoryList[0]}
                        onOpen={() => {
                          props.openOptoPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              birthDate: currentPatientEdit.nacimiento,
                            },
                            0,
                            recentOptometryIds,
                            async () => {
                              await closeOptoPanel(props);
                            },
                          );
                        }}
                      ></OptometryHistoryBox>
                    )}
                    {optometrySectionSeeMore &&
                      optometryHistoryList.length > 0 && (
                        <div>
                          {optometryHistoryList.slice(1).map((e, i) => {
                            return (
                              <OptometryHistoryBox
                                key={i}
                                opt={e}
                                onOpen={() => {
                                  let aux = recentOptometryIds;
                                  aux.optometria = e.id;
                                  props.openOptoPanel(
                                    {
                                      id: patientId,
                                      name:
                                        currentPatient.nombre +
                                        " " +
                                        currentPatient.apellidos,
                                      birthDate: currentPatientEdit.nacimiento,
                                    },
                                    0,
                                    aux,
                                    async () => {
                                      await closeOptoPanel(props);
                                    },
                                  );
                                }}
                              ></OptometryHistoryBox>
                            );
                          })}
                        </div>
                      )}
                    {optometryHistoryList.length > 0 && (
                      <div className="section-footer-button">
                        <ButtonIconH
                          text={
                            !optometrySectionSeeMore ? "Ver más" : "Ver menos"
                          }
                          small={true}
                          onClick={() => {
                            setOptometrySectionSeeMore(
                              !optometrySectionSeeMore,
                            );
                            if (optometrySectionSeeMore) {
                              scrollTo("[id='Optometría']");
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="patient-section" id="Gafas">
              <div className="section-header">
                <img
                  src="/images/menu-gafas.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Gafas</span>
                <div className="patient-section-actions">
                  <ButtonSectionHeader
                    icon="/images/new-white.svg"
                    text="Nuevo"
                    onClick={() => {
                      if (currentPatientEdit.idPaciente !== -1) {
                        props.openGlassesPanel(
                          {
                            id: patientId,
                            name:
                              currentPatient.nombre +
                              " " +
                              currentPatient.apellidos,
                          },
                          -1,
                          async () => {
                            await closeGlassesPanel(props);
                          },
                        );
                      }
                    }}
                  ></ButtonSectionHeader>
                  <div className="patient-section-actions-extra">
                    <ButtonSectionHeader
                      icon="/images/update-white.svg"
                      text="Actualizar"
                      onClick={async () => {
                        if (currentPatientEdit.idPaciente !== -1) {
                          await getGlassesHistory(patientId);
                        }
                      }}
                    ></ButtonSectionHeader>
                    <PrintExportMenu
                      onSelect={exportGlassesReport}
                      hasData={glassesHistoryList?.length > 0}
                      onNoData={showNoPrintDataPopup}
                    ></PrintExportMenu>
                    {/* <ButtonSectionHeader
                      icon="/images/export-white.svg"
                      text="Exportar"
                    ></ButtonSectionHeader> */}
                  </div>
                </div>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setToggleEyeglassesSection(!toggleEyeglassesSection);
                  }}
                >
                  <img
                    src={
                      toggleEyeglassesSection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {toggleEyeglassesSection && (
                <div className="section-content">
                  <div className="section-todo">
                    {glassesHistoryList.length > 0 && (
                      <span className="section-history-header">
                        {!glassesSectionSeeMore
                          ? "Última ficha de gafas"
                          : `Histórico (${glassesHistoryList.length})`}
                      </span>
                    )}
                    {glassesHistoryList.length > 0 && (
                      <div className="section-content-sep"></div>
                    )}
                    {glassesHistoryList.length > 0 && (
                      <GlassesHistoryBox
                        data={glassesHistoryList[0]}
                        onOpen={() => {
                          props.openGlassesPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                            },
                            glassesHistoryList[0].idFichaGafas,
                            async () => {
                              await closeGlassesPanel(props);
                            },
                          );
                        }}
                      ></GlassesHistoryBox>
                    )}
                    {glassesSectionSeeMore && glassesHistoryList.length > 0 && (
                      <div>
                        {glassesHistoryList.slice(1).map((e, i) => {
                          return (
                            <GlassesHistoryBox
                              key={i}
                              data={e}
                              onOpen={() => {
                                props.openGlassesPanel(
                                  {
                                    id: patientId,
                                    name:
                                      currentPatient.nombre +
                                      " " +
                                      currentPatient.apellidos,
                                  },
                                  e.idFichaGafas,
                                  async () => {
                                    await closeGlassesPanel(props);
                                  },
                                );
                              }}
                            ></GlassesHistoryBox>
                          );
                        })}
                      </div>
                    )}
                    {glassesHistoryList.length > 0 && (
                      <div className="section-footer-button">
                        <ButtonIconH
                          text={
                            !glassesSectionSeeMore ? "Ver más" : "Ver menos"
                          }
                          small={true}
                          onClick={() => {
                            setGlassesSectionSeeMore(!glassesSectionSeeMore);
                            if (glassesSectionSeeMore) {
                              scrollTo("[id='Gafas']");
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    )}
                    {glassesHistoryList.length === 0 && <div>SIN DATOS</div>}
                  </div>
                </div>
              )}
            </div>

            <div className="patient-section" id="Lentes de contacto">
              <div className="section-header">
                <img
                  src="/images/menu-lentillas.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Lentes de contacto</span>
                <div className="patient-section-actions">
                  <ButtonSectionHeader
                    icon="/images/new-white.svg"
                    text="Nuevo"
                    onClick={() => {
                      if (currentPatientEdit.idPaciente !== -1) {
                        props.openContactLensesPanel(
                          {
                            id: patientId,
                            name:
                              currentPatient.nombre +
                              " " +
                              currentPatient.apellidos,
                            openPanel: false,
                          },
                          -1,
                          async () => {
                            await closeCLPanel(props);
                          },
                        );
                      }
                    }}
                  ></ButtonSectionHeader>
                  <div className="patient-section-actions-extra">
                    <ButtonSectionHeader
                      icon="/images/update-white.svg"
                      text="Actualizar"
                    ></ButtonSectionHeader>
                    <PrintExportMenu
                      onSelect={exportContactLensesReport}
                      hasData={CLHistoryList?.length > 0}
                      onNoData={showNoPrintDataPopup}
                    ></PrintExportMenu>
                    {/* <ButtonSectionHeader
                      icon="/images/export-white.svg"
                      text="Exportar"
                    ></ButtonSectionHeader> */}
                  </div>
                </div>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setToggleContactLensesSection(!toggleContactLensesSection);
                  }}
                >
                  <img
                    src={
                      toggleContactLensesSection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {toggleContactLensesSection && (
                <div className="section-content">
                  <span className="section-todo">
                    {CLHistoryList.length > 0 && (
                      <span className="section-history-header">
                        {!CLSeeMore
                          ? "Última ficha de lentes de contacto"
                          : `Histórico (${CLHistoryList.length})`}
                      </span>
                    )}
                    {CLHistoryList.length > 0 && (
                      <div className="section-content-sep"></div>
                    )}
                    {CLHistoryList.length > 0 && (
                      <ContactLensesHistoryBox
                        data={CLHistoryList[0]}
                        onOpen={() => {
                          props.openContactLensesPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                            },
                            CLHistoryList[0].idFichaLentillas,
                            async () => {
                              await closeCLPanel(props);
                            },
                          );
                        }}
                      ></ContactLensesHistoryBox>
                    )}
                    {CLSeeMore && CLHistoryList.length > 0 && (
                      <div>
                        {CLHistoryList.slice(1).map((e, i) => {
                          return (
                            <ContactLensesHistoryBox
                              key={i}
                              data={e}
                              onOpen={() => {
                                props.openContactLensesPanel(
                                  {
                                    id: patientId,
                                    name:
                                      currentPatient.nombre +
                                      " " +
                                      currentPatient.apellidos,
                                  },
                                  e.idFichaLentillas,
                                  async () => {
                                    await closeCLPanel(props);
                                  },
                                );
                              }}
                            ></ContactLensesHistoryBox>
                          );
                        })}
                      </div>
                    )}
                    {CLHistoryList.length > 0 && (
                      <div className="section-footer-button">
                        <ButtonIconH
                          text={!CLSeeMore ? "Ver más" : "Ver menos"}
                          small={true}
                          onClick={() => {
                            setCLSeeMore(!CLSeeMore);
                            if (CLSeeMore) {
                              scrollTo("[id='Lentes de contacto']");
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    )}
                    {CLHistoryList.length === 0 && <div>SIN DATOS</div>}
                  </span>
                </div>
              )}
            </div>
            <div className="patient-section" id="Audiometría">
              <div className="section-header">
                <img
                  src="/images/menu-headphones.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Audiometrías</span>
                <div className="patient-section-actions">
                  <ButtonSectionHeader
                    icon="/images/new-white.svg"
                    text="Nuevo"
                    onClick={() => {
                      if (currentPatientEdit.idPaciente !== -1) {
                        props.openAudiometryPanel(
                          {
                            id: patientId,
                            name:
                              currentPatient.nombre +
                              " " +
                              currentPatient.apellidos,
                            openPanel: false,
                          },
                          -1,
                          async () => {
                            await closeAudiometryPanel(props);
                          },
                        );
                      }
                    }}
                  ></ButtonSectionHeader>
                  <div className="patient-section-actions-extra">
                    <ButtonSectionHeader
                      icon="/images/update-white.svg"
                      text="Actualizar"
                      onClick={async () => {
                        if (currentPatientEdit.idPaciente !== -1) {
                          await getAudiometryHistory(patientId);
                        }
                      }}
                    ></ButtonSectionHeader>
                    <PrintExportMenu
                      onSelect={exportAudiometryReport}
                      hasData={audiometryHistoryList?.length > 0}
                      onNoData={showNoPrintDataPopup}
                    ></PrintExportMenu>
                    {/* <ButtonSectionHeader
                      icon="/images/export-white.svg"
                      text="Exportar"
                    ></ButtonSectionHeader> */}
                  </div>
                </div>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setToggleAudiometrySection(!toggleAudiometrySection);
                  }}
                >
                  <img
                    src={
                      toggleAudiometrySection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {toggleAudiometrySection && (
                <div className="section-content">
                  <div className="section-todo">
                    {audiometryHistoryList.length > 0 && (
                      <span className="section-history-header">
                        {!audiometrySectionSeeMore
                          ? "Última ficha de audiometría"
                          : `Histórico (${audiometryHistoryList.length})`}
                      </span>
                    )}
                    {audiometryHistoryList.length > 0 && (
                      <div className="section-content-sep"></div>
                    )}
                    {audiometryHistoryList.length > 0 && (
                      <AudiometryHistoryBox
                        data={audiometryHistoryList[0]}
                        onOpen={(openPanel) => {
                          props.openAudiometryPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                              openPanel,
                            },
                            audiometryHistoryList[0].idAudiometria,
                            async () => {
                              await closeAudiometryPanel(props);
                            },
                          );
                        }}
                      ></AudiometryHistoryBox>
                    )}
                    {audiometrySectionSeeMore &&
                      audiometryHistoryList.length > 0 && (
                        <div>
                          {audiometryHistoryList.slice(1).map((e, i) => {
                            return (
                              <AudiometryHistoryBox
                                key={i}
                                data={e}
                                onOpen={(openPanel) => {
                                  props.openAudiometryPanel(
                                    {
                                      id: patientId,
                                      name:
                                        currentPatient.nombre +
                                        " " +
                                        currentPatient.apellidos,
                                      openPanel,
                                    },
                                    e.idAudiometria,
                                    async () => {
                                      await closeAudiometryPanel(props);
                                    },
                                  );
                                }}
                              ></AudiometryHistoryBox>
                            );
                          })}
                        </div>
                      )}
                    {audiometryHistoryList.length > 0 && (
                      <div className="section-footer-button">
                        <ButtonIconH
                          text={
                            !audiometrySectionSeeMore ? "Ver más" : "Ver menos"
                          }
                          small={true}
                          onClick={() => {
                            setAudiometrySectionSeeMore(
                              !audiometrySectionSeeMore,
                            );
                            if (audiometrySectionSeeMore) {
                              scrollTo("[id='Audiometría']");
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    )}
                    {audiometryHistoryList.length === 0 && <div>SIN DATOS</div>}
                  </div>
                </div>
              )}
            </div>
            <div className="patient-section" id="Audífonos">
              <div className="section-header">
                <img
                  src="/images/menu-audifonos.svg"
                  loading="lazy"
                  alt="Icon"
                  className="section-header-icon"
                ></img>
                <span>Audífonos</span>
                <div className="patient-section-actions">
                  <ButtonSectionHeader
                    icon="/images/new-white.svg"
                    text="Nuevo"
                    onClick={() => {
                      if (currentPatientEdit.idPaciente !== -1) {
                        props.openHearingAidsPanel(
                          {
                            id: patientId,
                            name:
                              currentPatient.nombre +
                              " " +
                              currentPatient.apellidos,
                          },
                          -1,
                          async () => {
                            await closeHearingAidsPanel(props);
                          },
                        );
                      }
                    }}
                  ></ButtonSectionHeader>
                  <div className="patient-section-actions-extra">
                    <ButtonSectionHeader
                      icon="/images/update-white.svg"
                      text="Actualizar"
                      onClick={async () => {
                        if (currentPatientEdit.idPaciente !== -1) {
                          await getHearingAidsHistory(patientId);
                        }
                      }}
                    ></ButtonSectionHeader>
                    <PrintExportMenu
                      onSelect={exportHearingAidsReport}
                      hasData={hearingAidsHistoryList?.length > 0}
                      onNoData={showNoPrintDataPopup}
                    ></PrintExportMenu>
                    {/* <ButtonSectionHeader
                      icon="/images/export-white.svg"
                      text="Exportar"
                    ></ButtonSectionHeader> */}
                  </div>
                </div>
                <button
                  className="toggle-section-icon"
                  onClick={() => {
                    setToggleHearingAidsgSection(!toggleHearingAidsSection);
                  }}
                >
                  <img
                    src={
                      toggleHearingAidsSection
                        ? "/images/arrow-up.svg"
                        : "/images/arrow-down.svg"
                    }
                    loading="lazy"
                    alt="Icon"
                    className="section-header-icon"
                  ></img>
                </button>
              </div>
              {toggleHearingAidsSection && (
                <div className="section-content">
                  <div className="section-todo">
                    {hearingAidsHistoryList.length > 0 && (
                      <span className="section-history-header">
                        {!hearingAidsSeeMore
                          ? "Última ficha de audífonos"
                          : `Histórico (${hearingAidsHistoryList.length})`}
                      </span>
                    )}
                    {hearingAidsHistoryList.length > 0 && (
                      <div className="section-content-sep"></div>
                    )}
                    {hearingAidsHistoryList.length > 0 && (
                      <HearingAidsHistoryBox
                        data={hearingAidsHistoryList[0]}
                        onOpen={() => {
                          props.openHearingAidsPanel(
                            {
                              id: patientId,
                              name:
                                currentPatient.nombre +
                                " " +
                                currentPatient.apellidos,
                            },
                            hearingAidsHistoryList[0].idFichaAudifonos,
                            async () => {
                              await closeHearingAidsPanel(props);
                            },
                          );
                        }}
                      ></HearingAidsHistoryBox>
                    )}
                    {hearingAidsSeeMore &&
                      hearingAidsHistoryList.length > 0 && (
                        <div>
                          {hearingAidsHistoryList.slice(1).map((e, i) => {
                            return (
                              <HearingAidsHistoryBox
                                key={i}
                                data={e}
                                onOpen={() => {
                                  props.openHearingAidsPanel(
                                    {
                                      id: patientId,
                                      name:
                                        currentPatient.nombre +
                                        " " +
                                        currentPatient.apellidos,
                                    },
                                    e.idFichaAudifonos,
                                    async () => {
                                      await closeHearingAidsPanel(props);
                                    },
                                  );
                                }}
                              ></HearingAidsHistoryBox>
                            );
                          })}
                        </div>
                      )}
                    {hearingAidsHistoryList.length > 0 && (
                      <div className="section-footer-button">
                        <ButtonIconH
                          text={!hearingAidsSeeMore ? "Ver más" : "Ver menos"}
                          small={true}
                          onClick={() => {
                            setHearingAidsSeeMore(!hearingAidsSeeMore);
                            if (hearingAidsSeeMore) {
                              scrollTo("[id='Audífonos']");
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    )}
                    {hearingAidsHistoryList.length === 0 && (
                      <div>SIN DATOS</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <CashVoucherPopup
        show={showCashVoucherPopup}
        patientId={patientId}
        onClose={() => openCashVoucherPopup(false)}
        createPopupQuestion={props.createPopupQuestion}
        removePopupQuestion={props.removePopupQuestion}
        onChangeNumCashVouchers={onChangeNumCashVouchers}
      />
      <LoyaltyPopup
        show={showLoyaltyPopup}
        idClient={currentPatient.idPaciente}
        onClose={() => openLoyaltyPopup(false)}
        createPopupQuestion={props.createPopupQuestion}
        removePopupQuestion={props.removePopupQuestion}
        onUpdateLoyaltyPoints={updateLoyaltyPoints}
        onUpdateDto={updatePatientDto}
      />
      <SendSMSPopup
        show={showSendSMSPopup}
        idPaciente={currentPatientEdit.idPaciente}
        nombrePaciente={headerName}
        telefonoPaciente={
          currentPatientEdit.movil || currentPatientEdit.telefono
        }
        onClose={() => openSendSMSPopup(false)}
        createPopupQuestion={props.createPopupQuestion}
        removePopupQuestion={props.removePopupQuestion}
      />
    </div>
  );
});

export default Patient;
